import React, { useState, useEffect, useRef } from 'react';
import { 
  FaArrowLeft, 
  FaCheckCircle, 
  FaUser, 
  FaTimes, 
  FaUserShield, 
  FaWallet, 
  FaBitcoin, 
  FaEthereum, 
  FaChartLine, 
  FaExchangeAlt, 
  FaWhatsapp,
  FaTelegram,
  FaHistory, 
  FaLock, 
  FaShieldAlt, 
  FaHeadset, 
  FaInfoCircle, 
  FaBell,
  FaUsers,
  FaDollarSign,
  FaDatabase,
  FaGlobe,
  FaArrowDown,
  FaLink,
  FaMinus,
  FaPlus,
  FaMobile
} from 'react-icons/fa';
import { FaEye } from 'react-icons/fa';
import { SiRipple, SiLitecoin, SiDogecoin, SiTether } from 'react-icons/si';
import { IoWallet, IoSwapVertical, IoTrendingUp, IoTrendingDown } from 'react-icons/io5';
import { Link } from 'react-router-dom';
import BottomNavigation from './BottomNavigation';
import LiveTransactionsBot from './LiveTransactionsBot';
import { useAuth } from '../security/security/AuthContext';
import axios from 'axios';
import CashoutView from './CashoutView';
import DepositRecord from './DepositRecord';
import WithdrawalRecord from './WithdrawalRecord';
import HotProductSection from './HotProductSection';
import WhatsAppFloat from './auth/WhatsAppFloat';
import CompanyShares from './CompanyShares';

import { FaStar, FaArrowRight, FaLightbulb, FaClock } from 'react-icons/fa';

// Import recharts components for the trading chart
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  AreaChart,
  Area,
  ReferenceLine
} from 'recharts';

const Home = () => {
  // State from original component
  const [selectedNav, setSelectedNav] = useState('home');
  const [showPopup, setShowPopup] = useState(true);
  const [currentView, setCurrentView] = useState('main');
  const [depositAmount, setDepositAmount] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [withdrawAmount, setWithdrawAmount] = useState('');
  const [openedGiftBoxes, setOpenedGiftBoxes] = useState([]);
  const [showInvestmentDialog, setShowInvestmentDialog] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [products, setProducts] = useState([]);
  const [toastNotification, setToastNotification] = useState(null);
  const [investmentSuccess, setInvestmentSuccess] = useState(null);
  const { userDetails, token, updateUserDetails, isLoading, isSuperLogin, exitSuperLogin } = useAuth();

  // Payment processing states
  const [showPaymentLoader, setShowPaymentLoader] = useState(false);
  const [paymentLoaderMessage, setPaymentLoaderMessage] = useState('');
  const [showTransactionForm, setShowTransactionForm] = useState(false);
  const [transactionCode, setTransactionCode] = useState('');
  const [isSubmittingPayment, setIsSubmittingPayment] = useState(false);
  const [paymentSuccess, setPaymentSuccess] = useState(false);
  const [isActivated, setIsActivated] = useState(false);
  const [hotProduct, setHotProduct] = useState(null);

  // Add these with your other useState declarations
const [expandedFAQItems, setExpandedFAQItems] = useState(new Set());
const [showTerms, setShowTerms] = useState(false);
const [imageLoaded, setImageLoaded] = useState(false);
const [showFullscreen, setShowFullscreen] = useState(false);

  // New states for crypto-specific features
  const [selectedCrypto, setSelectedCrypto] = useState('BTC');
  const [cryptoPrices, setCryptoPrices] = useState({
    BTC: { price: 68432.15, change: 2.34 },
    ETH: { price: 3950.77, change: -1.23 },
    XRP: { price: 0.5324, change: 3.45 },
    LTC: { price: 82.42, change: 1.78 },
    DOGE: { price: 0.1234, change: 5.67 },
    USDT: { price: 1.00, change: 0.01 }
  });
  const [chartTimeframe, setChartTimeframe] = useState('1D');
  const [marketTrends, setMarketTrends] = useState([]);
  const [showNotifications, setShowNotifications] = useState(false);
  const [notifications, setNotifications] = useState([
    { id: 1, message: "BTC price alert: Up 2.34% in the last 24h", time: "10 mins ago", read: false },
    { id: 2, message: "Mining rewards are automatically credited to your wallet", time: "1 hour ago", read: false },
    { id: 3, message: "New mining device available: ETH Miner Pro", time: "3 hours ago", read: false }
  ]);
  
  const authContext = useAuth();

  // Style object for inline styling
  const styles = {
    container: {
      backgroundColor: '#0F172A',
      color: '#E2E8F0',
      minHeight: '100vh',
      fontFamily: 'Inter, system-ui, sans-serif',
      paddingBottom: '80px',
    },
    header: {
      background: 'linear-gradient(135deg, #1E293B 0%, #0F172A 100%)',
      padding: '16px',
      borderBottom: '1px solid #1E3A5F',
    },
    welcomeText: {
      fontSize: '20px',
      fontWeight: '600',
      margin: '0 0 4px 0',
      color: '#F8FAFC',
    },
    userInfoContainer: {
      display: 'flex',
      alignItems: 'center',
      marginTop: '12px',
    },
    userIcon: {
      backgroundColor: '#2563EB',
      color: 'white',
      width: '40px',
      height: '40px',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginRight: '12px',
    },
    userDetails: {
      flex: 1,
    },
    userName: {
      fontSize: '16px',
      fontWeight: '500',
      color: '#F8FAFC',
      margin: 0,
    },
    userMobile: {
      fontSize: '12px',
      color: '#94A3B8',
      margin: '4px 0 0 0',
    },
    walletCard: {
      background: 'linear-gradient(135deg, #1E3A5F 0%, #0C4A6E 100%)',
      borderRadius: '12px',
      padding: '16px',
      margin: '16px',
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
      position: 'relative',
      overflow: 'hidden',
    },
    walletHeader: {
      fontSize: '14px',
      color: '#94A3B8',
      marginBottom: '8px',
    },
    walletAmount: {
      fontSize: '28px',
      fontWeight: 'bold',
      marginBottom: '8px',
      color: '#F8FAFC',
    },
    currencySymbol: {
      fontSize: '16px',
      marginRight: '4px',
      opacity: 0.7,
    },
    walletActions: {
      display: 'flex',
      gap: '12px',
      marginTop: '12px',
    },
    actionButton: {
      backgroundColor: '#2563EB',
      color: 'white',
      border: 'none',
      borderRadius: '8px',
      padding: '10px 16px',
      fontSize: '14px',
      fontWeight: '500',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      cursor: 'pointer',
      transition: 'all 0.2s ease',
    },
    cryptoSelector: {
      display: 'flex',
      overflowX: 'auto',
      margin: '16px',
      gap: '12px',
      paddingBottom: '8px',
    },
    cryptoOption: {
      backgroundColor: '#1E293B',
      borderRadius: '12px',
      padding: '12px',
      minWidth: '90px',
      cursor: 'pointer',
      border: '1px solid #334155',
      transition: 'all 0.2s ease',
    },
    activeCryptoOption: {
      backgroundColor: '#0C4A6E',
      borderColor: '#38BDF8',
    },
    cryptoIcon: {
      fontSize: '24px',
      marginBottom: '8px',
    },
    cryptoName: {
      fontSize: '14px',
      fontWeight: '500',
      color: '#F8FAFC',
    },
    cryptoPrice: {
      fontSize: '12px',
      color: '#94A3B8',
    },
    cryptoChange: {
      fontSize: '12px',
      fontWeight: '500',
      marginTop: '4px',
    },
    positiveChange: {
      color: '#10B981',
    },
    negativeChange: {
      color: '#EF4444',
    },
    chartContainer: {
      margin: '0 16px 24px',
      backgroundColor: '#1E293B',
      borderRadius: '12px',
      padding: '16px',
      border: '1px solid #334155',
    },
    chartHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '16px',
    },
    chartTitle: {
      fontSize: '16px',
      fontWeight: '600',
      color: '#F8FAFC',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
    },
    timeframeSelector: {
      display: 'flex',
      backgroundColor: '#0F172A',
      borderRadius: '8px',
      overflow: 'hidden',
    },
    timeframeOption: {
      padding: '6px 12px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#94A3B8',
      border: 'none',
      backgroundColor: 'transparent',
      cursor: 'pointer',
    },
    activeTimeframeOption: {
      backgroundColor: '#2563EB',
      color: 'white',
    },
    featuresGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      gap: '16px',
      margin: '16px',
    },
    featureItem: {
      backgroundColor: '#1E293B',
      borderRadius: '12px',
      padding: '16px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      border: '1px solid #334155',
    },
    featureIcon: {
      fontSize: '24px',
      color: '#38BDF8',
      marginBottom: '8px',
    },
    featureLabel: {
      fontSize: '12px',
      color: '#F8FAFC',
      textAlign: 'center',
    },
    sectionTitle: {
      fontSize: '18px',
      fontWeight: '600',
      margin: '24px 16px 16px',
      color: '#E2E8F0',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
    },
    marketTrendsCard: {
      backgroundColor: '#1E293B',
      borderRadius: '12px',
      margin: '0 16px 16px',
      border: '1px solid #334155',
      overflow: 'hidden',
    },
    marketTrendsList: {
      display: 'flex',
      flexDirection: 'column',
    },
    marketTrendItem: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '12px 16px',
      borderBottom: '1px solid #334155',
    },
    trendInfo: {
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
    },
    trendIcon: {
      width: '32px',
      height: '32px',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '16px',
    },
    trendDetails: {
      display: 'flex',
      flexDirection: 'column',
    },
    trendName: {
      fontSize: '14px',
      fontWeight: '500',
      color: '#F8FAFC',
    },
    trendSymbol: {
      fontSize: '12px',
      color: '#94A3B8',
    },
    trendPrice: {
      fontSize: '14px',
      fontWeight: '500',
      color: '#F8FAFC',
    },
    navItem: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '16px',
      borderBottom: '1px solid #334155',
      cursor: 'pointer',
    },
    navItemLabel: {
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      fontSize: '14px',
      fontWeight: '500',
      color: '#F8FAFC',
    },
    backButton: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      padding: '12px 16px',
      backgroundColor: 'transparent',
      border: 'none',
      color: '#E2E8F0',
      fontSize: '16px',
      cursor: 'pointer',
    },
    superLoginBanner: {
      backgroundColor: 'rgba(220, 38, 38, 0.9)',
      color: 'white',
      padding: '8px 16px',
      position: 'sticky',
      top: 0,
      zIndex: 100,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    superLoginText: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      fontSize: '14px',
      fontWeight: '500',
    },
    superLoginButton: {
      backgroundColor: 'white',
      color: '#DC2626',
      border: 'none',
      borderRadius: '4px',
      padding: '4px 8px',
      fontSize: '12px',
      fontWeight: '500',
      cursor: 'pointer',
    },
    popup: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.8)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000,
      padding: '16px',
    },
    popupContent: {
      backgroundColor: '#1E293B',
      borderRadius: '16px',
      width: '100%',
      maxWidth: '400px',
      padding: '24px',
      boxShadow: '0 10px 25px rgba(0, 0, 0, 0.5)',
      border: '1px solid #2563EB',
    },
    popupTitle: {
      fontSize: '20px',
      fontWeight: '700',
      color: '#F8FAFC',
      marginBottom: '16px',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
    },
    popupText: {
      fontSize: '14px',
      color: '#E2E8F0',
      marginBottom: '16px',
      lineHeight: 1.5,
    },
    popupButtons: {
      display: 'flex',
      gap: '12px',
      marginTop: '24px',
    },
    popupButton: {
      flex: 1,
      padding: '12px',
      borderRadius: '8px',
      border: 'none',
      fontSize: '14px',
      fontWeight: '500',
      cursor: 'pointer',
    },
    telegramButton: {
      backgroundColor: '#0088cc',
      color: 'white',
    },
    closeButton: {
      backgroundColor: '#475569',
      color: 'white',
    },
    logoutButton: {
      backgroundColor: '#EF4444',
      color: 'white',
      marginTop: '12px',
      width: '100%',
      padding: '12px',
      borderRadius: '8px',
      border: 'none',
      fontSize: '14px',
      fontWeight: '500',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '8px',
    },
    notificationBell: {
      position: 'relative',
      fontSize: '22px',
      color: '#F8FAFC',
      cursor: 'pointer',
    },
    notificationBadge: {
      position: 'absolute',
      top: '-5px',
      right: '-5px',
      width: '16px',
      height: '16px',
      borderRadius: '50%',
      backgroundColor: '#EF4444',
      color: 'white',
      fontSize: '10px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    notificationsPanel: {
      position: 'absolute',
      top: '40px',
      right: '0',
      width: '300px',
      backgroundColor: '#1E293B',
      borderRadius: '12px',
      boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
      border: '1px solid #334155',
      zIndex: 100,
    },
    notificationHeader: {
      padding: '12px 16px',
      borderBottom: '1px solid #334155',
      fontSize: '14px',
      fontWeight: '600',
      color: '#F8FAFC',
    },
    notificationList: {
      maxHeight: '300px',
      overflowY: 'auto',
    },
    notificationItem: {
      padding: '12px 16px',
      borderBottom: '1px solid #334155',
      cursor: 'pointer',
    },
    notificationMessage: {
      fontSize: '13px',
      color: '#E2E8F0',
      marginBottom: '4px',
    },
    notificationTime: {
      fontSize: '11px',
      color: '#94A3B8',
    },
    unreadNotification: {
      backgroundColor: 'rgba(37, 99, 235, 0.1)',
    },
    chartPlaceholder: {
      height: '250px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#94A3B8',
      fontSize: '14px',
    },
    cryptoBadges: {
      display: 'flex',
      position: 'absolute',
      top: '12px',
      right: '12px',
    },
    cryptoBadge: {
      width: '24px',
      height: '24px',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '14px',
      marginLeft: '-8px',
      border: '1px solid #0F172A',
    },
    toast: {
      position: 'fixed',
      bottom: '80px',
      left: '50%',
      transform: 'translateX(-50%)',
      backgroundColor: '#1E293B',
      color: 'white',
      padding: '12px 16px',
      borderRadius: '8px',
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      zIndex: 1001,
      width: '90%',
      maxWidth: '400px',
      border: '1px solid',
    },
    successToast: {
      borderColor: '#10B981',
    },
    errorToast: {
      borderColor: '#EF4444',
    }
  };

  // Add this to your component logic
const handleCloseToast = () => {
  // First set the exiting state
  setToastNotification(prev => ({
    ...prev,
    isExiting: true
  }));
  
  // Then remove toast after animation completes
  setTimeout(() => {
    setToastNotification(null);
  }, 400); // Match the animation duration
};

// Also add auto-dismiss functionality if desired
useEffect(() => {
  if (toastNotification && !toastNotification.isExiting) {
    const timer = setTimeout(() => {
      handleCloseToast();
    }, 5000); // Auto-dismiss after 5 seconds
    
    return () => clearTimeout(timer);
  }
}, [toastNotification]);

  // Generate chart data
  const generateChartData = (timeframe, crypto) => {
    const now = new Date();
    const data = [];
    let numPoints;
    let startValue;
    let volatility;
    
    switch(timeframe) {
      case '1H':
        numPoints = 60;
        startValue = cryptoPrices[crypto].price * 0.995;
        volatility = 0.001;
        break;
      case '1D':
        numPoints = 24;
        startValue = cryptoPrices[crypto].price * 0.97;
        volatility = 0.005;
        break;
      case '1W':
        numPoints = 7;
        startValue = cryptoPrices[crypto].price * 0.93;
        volatility = 0.01;
        break;
      case '1M':
        numPoints = 30;
        startValue = cryptoPrices[crypto].price * 0.85;
        volatility = 0.02;
        break;
      case '1Y':
        numPoints = 12;
        startValue = cryptoPrices[crypto].price * 0.7;
        volatility = 0.05;
        break;
      default:
        numPoints = 24;
        startValue = cryptoPrices[crypto].price * 0.97;
        volatility = 0.005;
    }
    
    let value = startValue;
    
    for (let i = 0; i < numPoints; i++) {
      const date = new Date(now);
      
      switch(timeframe) {
        case '1H':
          date.setMinutes(now.getMinutes() - (numPoints - i));
          break;
        case '1D':
          date.setHours(now.getHours() - (numPoints - i));
          break;
        case '1W':
          date.setDate(now.getDate() - (numPoints - i));
          break;
        case '1M':
          date.setDate(now.getDate() - (numPoints - i));
          break;
        case '1Y':
          date.setMonth(now.getMonth() - (numPoints - i));
          break;
        default:
          date.setHours(now.getHours() - (numPoints - i));
      }
      
      // Random walk with tendency to move up
      const change = (Math.random() - 0.45) * volatility * value;
      value += change;
      
      // Ensure the final point is the current price
      if (i === numPoints - 1) {
        value = cryptoPrices[crypto].price;
      }
      
      let timeLabel;
      switch(timeframe) {
        case '1H':
          timeLabel = date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
          break;
        case '1D':
          timeLabel = date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
          break;
        case '1W':
          timeLabel = date.toLocaleDateString([], { weekday: 'short' });
          break;
        case '1M':
          timeLabel = date.toLocaleDateString([], { day: 'numeric', month: 'short' });
          break;
        case '1Y':
          timeLabel = date.toLocaleDateString([], { month: 'short' });
          break;
        default:
          timeLabel = date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
      }
      
      data.push({
        time: timeLabel,
        price: value,
        date: date,
      });
    }
    
    return data;
  };

  // Generate market trends data
  const generateMarketTrends = () => {
    return [
      { id: 'BTC', name: 'Bitcoin', symbol: 'BTC/USD', price: cryptoPrices.BTC.price, change: cryptoPrices.BTC.change, icon: <FaBitcoin style={{color: '#F7931A'}} /> },
      { id: 'ETH', name: 'Ethereum', symbol: 'ETH/USD', price: cryptoPrices.ETH.price, change: cryptoPrices.ETH.change, icon: <FaEthereum style={{color: '#627EEA'}} /> },
      { id: 'XRP', name: 'Ripple', symbol: 'XRP/USD', price: cryptoPrices.XRP.price, change: cryptoPrices.XRP.change, icon: <SiRipple style={{color: '#0066B1'}} /> },
      { id: 'LTC', name: 'Litecoin', symbol: 'LTC/USD', price: cryptoPrices.LTC.price, change: cryptoPrices.LTC.change, icon: <SiLitecoin style={{color: '#B5B5B5'}} /> },
      { id: 'DOGE', name: 'Dogecoin', symbol: 'DOGE/USD', price: cryptoPrices.DOGE.price, change: cryptoPrices.DOGE.change, icon: <SiDogecoin style={{color: '#C3A634'}} /> },
    ];
  };

  useEffect(() => {
    if (!isLoading && userDetails?.mobile) {
      setPhoneNumber(userDetails.mobile);
    }
    if (!isLoading && userDetails?.email) {
      fetchAvailableProducts();
    }
    
    // Generate market trends data
    setMarketTrends(generateMarketTrends());
    
    // Simulate live price updates
    const interval = setInterval(() => {
      setCryptoPrices(prevPrices => {
        const newPrices = { ...prevPrices };
        Object.keys(newPrices).forEach(crypto => {
          const change = (Math.random() - 0.485) * 0.5;
          newPrices[crypto] = {
            price: Math.max(newPrices[crypto].price * (1 + change / 100), 0.01),
            change: Math.max(Math.min(newPrices[crypto].change + change, 10), -10)
          };
        });
        return newPrices;
      });
    }, 3000);
    
    return () => clearInterval(interval);
  }, [userDetails, isLoading]);

  const formatPhoneNumber = (number) => {
    if (number.startsWith('07') || number.startsWith('01')) {
      return '254' + number.slice(1);
    }
    return number;
  };

  const getTimeBasedGreeting = () => {
  const hour = new Date().getHours();
  
  if (hour >= 5 && hour < 12) {
    return "Good Morning";
  } else if (hour >= 12 && hour < 17) {
    return "Good Afternoon";
  } else if (hour >= 17 && hour < 21) {
    return "Good Evening";
  } else {
    return "Good Night";
  }
};

  const refreshUserData = async () => {
    try {
      const userResponse = await axios.get(`https://api.globallequityfinance.com/api/v1/auth/${userDetails.email}`, {
        headers: {
          'Authorization': token
        }
      });
      updateUserDetails(userResponse.data);
    } catch (error) {
      console.error('Error refreshing user data:', error);
      setToastNotification({ message: 'Failed to refresh user data', type: 'error' });
    }
  };

  const refreshProducts = async () => {
    try {
      const response = await axios.get(`https://api.globallequityfinance.com/api/products/available/${userDetails.email}`);
      if (response.data && Array.isArray(response.data)) {
        setProducts(response.data);
      }
    } catch (error) {
      console.error('Error refreshing products:', error);
    }
  };

  const refreshAllData = async () => {
    await Promise.all([
      refreshUserData(),
      refreshProducts()
    ]);
  };

  useEffect(() => {
    if (currentView === 'main') {
      refreshAllData();
    }
  }, [currentView]);

  const handlePaymentSuccess = async () => {
    await refreshAllData();
    setCurrentView('paymentSuccess');
  };

  const fetchAvailableProducts = async () => {
    try {
      const [productsResponse, hotProductsResponse] = await Promise.all([
        axios.get(`https://api.globallequityfinance.com/api/products/available/${userDetails.email}`),
        axios.get('https://api.globallequityfinance.com/api/products/hot')
      ]);
      
      if (productsResponse.data && Array.isArray(productsResponse.data)) {
        setProducts(productsResponse.data.filter(p => p.productType === 'NORMAL'));
      }
      
      if (hotProductsResponse.data && hotProductsResponse.data.length > 0) {
        setHotProduct(hotProductsResponse.data[0]);
      }
    } catch (error) {
      console.error('Error fetching products:', error);
      setToastNotification({ message: 'Failed to fetch mining devices. Please try again.', type: 'error' });
    }
  };

  const handleInvest = (product) => {
    setSelectedProduct(product);
    setQuantity(1);
    setShowInvestmentDialog(true);
  };

  const handleCloseInvestmentDialog = () => {
    setShowInvestmentDialog(false);
    setSelectedProduct(null);
    setQuantity(1);
  };

  const handleQuantityChange = (newQuantity) => {
    setQuantity(newQuantity);
  };

  const calculateTotalBalance = () => {
    const wallet = Number(userDetails.wallet) || 0;
    const invitationIncome = Number(userDetails.invitationIncome) || 0;
    return (wallet + invitationIncome).toLocaleString();
  };

  const handleInvestNow = async () => {
    try {
      const response = await axios.post('https://api.globallequityfinance.com/api/investments/invest', null, {
        params: {
          userEmail: userDetails.email,
          productId: selectedProduct.id,
          quantity: quantity
        }
      });
      
      if (response.status === 200) {
        await refreshAllData();
        setShowInvestmentDialog(false);
        setInvestmentSuccess(response.data);
        setCurrentView('investmentSuccess');
      }
    } catch (error) {
      if (error.response && error.response.status === 400) {
        setToastNotification({ message: error.response.data, type: 'error' });
        setCurrentView('deposit');
        setDepositAmount((selectedProduct.price * quantity).toString());
      } else {
        console.error('Error making investment:', error);
        setToastNotification({ message: 'Error, please select another package!', type: 'error' });
      }
    }
  };

  const handlePaymentSubmit = async (e) => {
    e.preventDefault();
    setShowPaymentLoader(true);
    setPaymentLoaderMessage('Please check your phone to complete payment.');

    const formattedPhoneNumber = formatPhoneNumber(phoneNumber);
    const requestData = {
      PhoneNumber: formattedPhoneNumber,
      Amount: parseInt(depositAmount),
    };

    try {
      await axios.post('https://api.globallequityfinance.com/mobile-money/stk-transaction-request', requestData, {
        headers: {
          'Authorization': token
        }
      });
      
      setTimeout(() => {
        setPaymentLoaderMessage('Processing transaction...');
      }, 20000);

      setTimeout(() => {
        checkPaymentStatus(formattedPhoneNumber);
      }, 27000);
    } catch (error) {
      console.error(error);
      setShowPaymentLoader(false);
      setToastNotification({ message: 'Failed to initiate payment. Please try again.', type: 'error' });
    }
  };

  const checkPaymentStatus = async (phoneNumber) => {
    try {
      const response = await axios.get(`https://api.globallequityfinance.com/mobile-money/transactions/check-payment/${phoneNumber}`, {
        headers: {
          'Authorization': token
        }
      });
  
      if (response.data.paymentFound) {
        await processTransaction(phoneNumber);
        setPaymentSuccess(true);
        setShowPaymentLoader(false);
        setToastNotification({ message: 'Payment successful!', type: 'success' });
        setCurrentView('paymentSuccess');
      } else {
        setShowPaymentLoader(false);
        setShowTransactionForm(true);
      }
    } catch (error) {
      console.error('Error checking payment status:', error);
      setShowPaymentLoader(false);
      setToastNotification({ message: 'Failed to check payment status. Please try again.', type: 'error' });
    }
  };

  const processTransaction = async (phoneNumber) => {
    try {
      const response = await axios.post('https://api.globallequityfinance.com/mobile-money/users/activate', {
        phoneNumber: phoneNumber,
        email: userDetails.email
      }, {
        headers: {
          'Authorization': token
        }
      });
  
      if (response.data.message) {
        setIsActivated(true);
        await refreshAllData();
      }
    } catch (error) {
      console.error('Error processing transaction:', error);
      throw error;
    }
  };

  const handleTransactionCodeSubmit = async (e) => {
    e.preventDefault();
    setIsSubmittingPayment(true);
  
    const formattedPhoneNumber = formatPhoneNumber(phoneNumber);
  
    try {
      const verifyResponse = await axios.post('https://api.globallequityfinance.com/mobile-money/transactions/verify', {
        phoneNumber: formattedPhoneNumber,
        transactionCode: transactionCode
      }, {
        headers: {
          'Authorization': token
        }
      });
  
      if (verifyResponse.data.verified) {
        await processTransaction(formattedPhoneNumber);
        await refreshAllData();
        setPaymentSuccess(true);
        setCurrentView('paymentSuccess');
        setToastNotification({ message: 'Payment verified successfully!', type: 'success' });
      } else {
        setToastNotification({ message: 'Invalid transaction code. Please try again.', type: 'error' });
      }
    } catch (error) {
      console.error('Error verifying transaction:', error);
      setToastNotification({ message: 'Failed to verify transaction. Please try again.', type: 'error' });
    } finally {
      setIsSubmittingPayment(false);
    }
  };

  const getCryptoIcon = (crypto) => {
    switch(crypto) {
      case 'BTC':
        return <FaBitcoin style={{color: '#F7931A'}} />;
      case 'ETH':
        return <FaEthereum style={{color: '#627EEA'}} />;
      case 'XRP':
        return <SiRipple style={{color: '#0066B1'}} />;
      case 'LTC':
        return <SiLitecoin style={{color: '#B5B5B5'}} />;
      case 'DOGE':
        return <SiDogecoin style={{color: '#C3A634'}} />;
      case 'USDT':
        return <SiTether style={{color: '#26A17B'}} />;
      default:
        return <FaBitcoin />;
    }
  };

  const joinTelegramChannel = () => {
    const telegramLink = "https://chat.whatsapp.com/EymMO3jtCta7FCNvgelOy4";
    window.open(telegramLink, '_blank');
  };



  const features = [
    { name: "Deposit", icon: <FaWallet style={styles.featureIcon} />, view: 'deposit' },
    { name: "My Deposits", icon: <FaChartLine style={styles.featureIcon} />, view: 'mydeposit' },
    { name: "My Cashouts", icon: <IoSwapVertical style={styles.featureIcon} />, view: 'withdrawal' },
    { name: "FAQs", icon: <FaHeadset style={styles.featureIcon} />, view: 'faqs' },
    { name: "Legal Docs", icon: <FaHeadset style={styles.featureIcon} />, view: 'documents' },
    { name: "Helpline", icon: <FaHeadset style={styles.featureIcon} />, view: 'customer' },
  ];

  // View renderers
  const renderInvestmentSuccessView = () => (
    <div style={{padding: '16px'}}>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        marginBottom: '24px'
      }}>
        <FaCheckCircle style={{
          fontSize: '64px',
          color: '#10B981',
          marginBottom: '16px'
        }} />
        <h2 style={{
          fontSize: '24px',
          fontWeight: '600',
          color: '#F8FAFC',
          marginBottom: '8px'
        }}>Mining Operation Started!</h2>
      </div>
      
      <div style={{
        backgroundColor: '#1E293B',
        borderRadius: '12px',
        padding: '16px',
        marginBottom: '24px',
        border: '1px solid #334155'
      }}>
        <h3 style={{
          fontSize: '18px',
          fontWeight: '600',
          color: '#F8FAFC',
          marginBottom: '16px'
        }}>{investmentSuccess.productName}</h3>
        
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          padding: '12px 0',
          borderBottom: '1px solid #334155'
        }}>
          <span style={{color: '#94A3B8'}}>Quantity</span>
          <span style={{color: '#F8FAFC', fontWeight: '500'}}>{quantity}</span>
        </div>
        
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          padding: '12px 0',
          borderBottom: '1px solid #334155'
        }}>
          <span style={{color: '#94A3B8'}}>Investment Amount</span>
          <span style={{color: '#F8FAFC', fontWeight: '500'}}>KES {investmentSuccess.investedAmount.toLocaleString()}</span>
        </div>
        
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          padding: '12px 0',
          borderBottom: '1px solid #334155'
        }}>
          <span style={{color: '#94A3B8'}}>Daily Yield</span>
          <span style={{color: '#10B981', fontWeight: '500'}}>KES {investmentSuccess.dailyIncome.toLocaleString()}</span>
        </div>
        
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          padding: '12px 0',
          borderBottom: '1px solid #334155'
        }}>
          <span style={{color: '#94A3B8'}}>Total Expected Return</span>
          <span style={{color: '#10B981', fontWeight: '500'}}>KES {investmentSuccess.totalIncome.toLocaleString()}</span>
        </div>
        
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          padding: '12px 0'
        }}>
          <span style={{color: '#94A3B8'}}>Mining Period Ends</span>
          <span style={{color: '#F8FAFC', fontWeight: '500'}}>{investmentSuccess.validUntil.split('T')[0]}</span>
        </div>
      </div>
      
      <div style={{
        backgroundColor: '#0F172A',
        borderRadius: '12px',
        padding: '16px',
        marginBottom: '24px',
        border: '1px solid #334155'
      }}>
        <h3 style={{
          fontSize: '16px',
          fontWeight: '600',
          color: '#F8FAFC',
          marginBottom: '12px',
          display: 'flex',
          alignItems: 'center',
          gap: '8px'
        }}>
          <FaInfoCircle style={{color: '#38BDF8'}} />
          How to Receive Mining Rewards
        </h3>
        
        <p style={{
          fontSize: '14px',
          color: '#94A3B8',
          marginBottom: '8px',
          lineHeight: 1.5
        }}>
          Your mining rewards will be added to your wallet every hour and can be collected from your Mining Dashboard.
        </p>
        
        <p style={{
          fontSize: '14px',
          color: '#94A3B8',
          lineHeight: 1.5
        }}>
          When the mining period ends, your initial investment will automatically return to your balance.
        </p>
      </div>
      
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '12px'
      }}>
        <button 
          style={{
            backgroundColor: '#2563EB',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            padding: '14px',
            fontSize: '16px',
            fontWeight: '600',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px'
          }}
          onClick={() => window.location.href = '/history'}
        >
          <FaChartLine /> View Mining Dashboard
        </button>
        
        <button 
          style={{
            backgroundColor: 'transparent',
            color: '#94A3B8',
            border: '1px solid #334155',
            borderRadius: '8px',
            padding: '14px',
            fontSize: '14px',
            fontWeight: '500',
            cursor: 'pointer'
          }}
          onClick={() => setCurrentView('main')}
        >
          Back to Home
        </button>
      </div>
    </div>
  );

  const renderDepositRecord = () => (
    <div>
      <DepositRecord userDetails={userDetails} token={authContext.token} />
    </div>
  );

  const renderWithdrawalRecord = () => (
    <div>
      <WithdrawalRecord userDetails={userDetails} token={token} />
    </div>
  );

  const renderCustomerService = () => {
    const whatsappservice = () => {
      const whatsappLink = "https://wa.link/3fdrj7";
      window.open(whatsappLink, '_blank');
    };

    
    
    const joinTelegramChannel = () => {
      const telegramLink = "https://chat.whatsapp.com/EymMO3jtCta7FCNvgelOy4";
      window.open(telegramLink, '_blank');
    };

    
    return (
      <div className="fp-support-container">
        
        <div className="fp-support-sections">
          <div className="fp-support-section fp-contact-section">
            <div className="fp-section-header">
              <div className="fp-section-header-pill">
                <FaStar className="fp-header-pill-icon" />
                <span>Support and Channel</span>
              </div>
            </div>
            
            <div className="fp-section-content">
              <p className="fp-contact-intro">Our team of experts is ready to assist you with any questions or issues you may have.</p>
              
              <div className="fp-contact-buttons">
                <button 
                  className="fp-button fp-whatsapp-button"
                  onClick={whatsappservice}
                >
                  <FaWhatsapp className="fp-button-icon" /> 
                  <span className="fp-button-text">Contact Support</span>
                  <FaArrowRight className="fp-button-arrow" />
                </button>

                <button 
                  className="fp-button fp-whatsapp-button"
                  onClick={joinTelegramChannel}
                >
                  <FaWhatsapp className="fp-button-icon" /> 
                  <span className="fp-button-text">WhatsApp Channel</span>
                  <FaArrowRight className="fp-button-arrow" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const   renderCashoutView = () => (
    <CashoutView 
      setCurrentView={setCurrentView}
      userDetails={userDetails}
      token={token}
      calculateTotalBalance={calculateTotalBalance}
      setToastNotification={setToastNotification}
    />
  );


  const renderAboutUs = () => (
    <div className="fp-about-container">
      <div className="fp-about-header">
        <div className="fp-about-header-accent"></div>
        <h1 className="fp-about-title">About Global Equity</h1>
        <p className="fp-about-tagline">Your Gateway to Cryptocurrency Wealth</p>
      </div>
      
      <div className="fp-about-cards-container">
        <div className="fp-about-card fp-card-mission">
          <div className="fp-card-icon-wrapper">
            <FaGlobe className="fp-card-icon" />
            <div className="fp-icon-glow"></div>
          </div>
          <div className="fp-card-content">
            <h2 className="fp-card-title">Our Mission</h2>
            <p className="fp-card-text">
              At Global Equity, we're democratizing access to cryptocurrency investing. Our mission is to provide a secure, intuitive platform that empowers everyone—from beginners to institutional investors—to participate in the digital asset revolution with confidence and strategic insight.
            </p>
            <div className="fp-card-corner-accent"></div>
          </div>
        </div>
        
        <div className="fp-about-card fp-card-approach">
          <div className="fp-card-icon-wrapper">
            <FaChartLine className="fp-card-icon" />
            <div className="fp-icon-glow"></div>
          </div>
          <div className="fp-card-content">
            <h2 className="fp-card-title">Investment Philosophy</h2>
            <p className="fp-card-text">
              We believe that cryptocurrency investing should be accessible to everyone, not just those with technical expertise or substantial capital. Our data-driven approach combines AI-powered analytics with fundamental research to identify high-potential digital assets across market cycles, optimizing both growth and risk management.
            </p>
            <div className="fp-card-corner-accent"></div>
          </div>
        </div>
        
        <div className="fp-about-card fp-card-technology">
          <div className="fp-card-icon-wrapper">
            <FaDatabase className="fp-card-icon" />
            <div className="fp-icon-glow"></div>
          </div>
          <div className="fp-card-content">
            <h2 className="fp-card-title">Portfolio Strategies</h2>
            <p className="fp-card-text">
              Our investment portfolios span the entire cryptocurrency ecosystem. From blue-chip assets like Bitcoin and Ethereum to emerging Layer-1 blockchains, DeFi protocols, and metaverse tokens, we construct diversified portfolios tailored to your risk tolerance and investment timeline. Our automated rebalancing ensures optimal allocation as market conditions evolve.
            </p>
            <div className="fp-card-corner-accent"></div>
          </div>
        </div>
        
        <div className="fp-about-card fp-card-security">
          <div className="fp-card-icon-wrapper">
            <FaShieldAlt className="fp-card-icon" />
            <div className="fp-icon-glow"></div>
          </div>
          <div className="fp-card-content">
            <h2 className="fp-card-title">Security & Transparency</h2>
            <p className="fp-card-text">
              Security is our highest priority. We employ institutional-grade custody solutions with multi-signature wallets, cold storage, and regular security audits to safeguard your digital assets. Our transparent investment platform provides real-time portfolio tracking, comprehensive performance analytics, and detailed transaction records, giving you complete visibility into your investments.
            </p>
            <div className="fp-card-corner-accent"></div>
          </div>
        </div>
      </div>
    </div>
  );

  const renderPaymentProcessView = () => (
    <div style={{padding: '16px'}}>
      {!showPaymentLoader && !showTransactionForm && (
        <div>
          <h2 style={{
            fontSize: '20px',
            fontWeight: '600',
            color: '#F8FAFC',
            marginBottom: '24px'
          }}>
            Confirm Payment Details
          </h2>
          
          <div style={{
            backgroundColor: '#1E293B',
            borderRadius: '12px',
            padding: '16px',
            marginBottom: '24px',
            border: '1px solid #334155'
          }}>
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              padding: '12px 0',
              borderBottom: '1px solid #334155'
            }}>
              <span style={{color: '#94A3B8'}}>Deposit Amount</span>
              <span style={{color: '#F8FAFC', fontWeight: '500'}}>KES {depositAmount}</span>
            </div>
            
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              padding: '12px 0'
            }}>
              <span style={{color: '#94A3B8'}}>Payment Method</span>
              <span style={{color: '#F8FAFC', fontWeight: '500'}}>Mobile Money ({phoneNumber})</span>
            </div>
          </div>
          
          <button 
            style={{
              width: '100%',
              backgroundColor: '#2563EB',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              padding: '14px',
              fontSize: '16px',
              fontWeight: '600',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px'
            }}
            onClick={handlePaymentSubmit}
          >
            Proceed to Payment
          </button>
        </div>
      )}

      {showPaymentLoader && (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '40px 16px',
          textAlign: 'center'
        }}>
          <div style={{
            width: '48px',
            height: '48px',
            border: '4px solid #1E293B',
            borderTop: '4px solid #38BDF8',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            marginBottom: '24px'
          }}></div>
          
          <h3 style={{
            fontSize: '18px',
            fontWeight: '600',
            color: '#F8FAFC',
            marginBottom: '12px'
          }}>
            Processing Payment
          </h3>
          
          <p style={{
            fontSize: '14px',
            color: '#94A3B8',
            maxWidth: '320px',
            lineHeight: 1.5
          }}>
            {paymentLoaderMessage}
          </p>
        </div>
      )}

      {showTransactionForm && (
        <div style={{padding: '16px'}}>
          <div style={{
            backgroundColor: '#1E293B',
            borderRadius: '12px',
            padding: '20px',
            marginBottom: '24px',
            border: '1px solid #EF4444',
            textAlign: 'center'
          }}>
            <h3 style={{
              fontSize: '18px',
              fontWeight: '600',
              color: '#EF4444',
              marginBottom: '12px'
            }}>
              Payment Not Detected
            </h3>
            
            <p style={{
              fontSize: '14px',
              color: '#94A3B8',
              marginBottom: '16px',
              lineHeight: 1.5
            }}>
              We couldn't detect your payment. Please try initiating the payment again.
            </p>
            
            <button 
              style={{
                backgroundColor: '#475569',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                padding: '12px 24px',
                fontSize: '14px',
                fontWeight: '500',
                cursor: 'pointer'
              }}
              onClick={() => setCurrentView('deposit')}
            >
              Try Again
            </button>
          </div>
        </div>
      )}
    </div>
  );

  const renderPaymentSuccessView = () => (
    <div style={{padding: '16px'}}>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        marginBottom: '24px'
      }}>
        <FaCheckCircle style={{
          fontSize: '64px',
          color: '#10B981',
          marginBottom: '16px'
        }} />
        
        <h2 style={{
          fontSize: '24px',
          fontWeight: '600',
          color: '#F8FAFC',
          marginBottom: '8px'
        }}>
          Payment Successful!
        </h2>
        
        <p style={{
          fontSize: '16px',
          color: '#94A3B8',
          marginBottom: '24px'
        }}>
          Your payment of KES {depositAmount} has been processed successfully.
        </p>
        
        {isActivated && (
          <div style={{
            backgroundColor: 'rgba(16, 185, 129, 0.1)',
            borderRadius: '8px',
            padding: '12px 16px',
            marginBottom: '24px',
            width: '100%',
            border: '1px solid rgba(16, 185, 129, 0.3)'
          }}>
            <p style={{color: '#10B981', fontWeight: '500'}}>
              Your wallet has been successfully topped up!
            </p>
          </div>
        )}
        
        <button 
          style={{
            width: '100%',
            backgroundColor: '#2563EB',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            padding: '14px',
            fontSize: '16px',
            fontWeight: '600',
            cursor: 'pointer'
          }}
          onClick={async () => {
            await refreshAllData();
            setCurrentView('main');
            setDepositAmount('');
            setPaymentSuccess(false);
            setShowTransactionForm(false);
          }}
        >
          Back to Dashboard
        </button>
      </div>
    </div>
  );


 const renderFAQsView = () => {
  const faqs = [
    {
      question: "What is Global Equity Finance?",
      answer: "Global Equity Finance is an online investment platform that allows users to buy and manage shares from global companies while tracking their portfolio and earnings in real-time."
    },
    {
      question: "How do I register on Global Equity Finance?",
      answer: "Visit our platform, click 'Sign Up,' and fill in your personal and financial details. You'll need a valid phone number, national ID, and an M-PESA or bank account."
    },
    {
      question: "Is Global Equity Finance legitimate?",
      answer: "Yes, Global Equity Finance operates under standard investment principles and offers transparent investment tools. However, like any financial platform, users are encouraged to do their own research before investing."
    },
    {
      question: "What currencies are supported?",
      answer: "Currently, your portfolio and transaction history are displayed in Kenyan Shillings (KES). Investments may be in foreign currencies (e.g., USD) but will be converted at prevailing exchange rates."
    },
    {
      question: "How do I deposit funds into my account?",
      answer: "To deposit: Log into your account, click the 'Deposit' button on the dashboard, follow the instructions for M-PESA or mobile money, and confirm payment."
    },
    {
      question: "How can I withdraw my earnings?",
      answer: "Click on the 'Withdraw' button, enter the amount, choose your preferred payout method. Funds will be sent to your M-PESA or bank account within 24hrs."
    },
    {
      question: "What is the minimum deposit amount?",
      answer: "The minimum deposit is KES 300. This allows new users to get started with small investments."
    },
    {
      question: "Can I track the shares I own?",
      answer: "Yes. Your dashboard displays the shares you've purchased (e.g., MSFT – Microsoft), their value, and live market updates."
    },
    {
      question: "What are the risks of investing?",
      answer: "All investments carry some level of risk. Share prices can go up or down based on market conditions. You may lose part or all of your investment, so always invest responsibly."
    },
    {
      question: "Do I earn dividends from the shares I buy?",
      answer: "Yes, if the company whose shares you own issues dividends, you may receive earnings. These will be reflected under the 'Earnings' section in your dashboard."
    },
    {
      question: "Where can I view my transaction history?",
      answer: "Click on the 'History' icon at the bottom menu to see all your past deposits, withdrawals, and share transactions."
    },
    {
      question: "How do I get help or support?",
      answer: "You can reach out to us via WhatsApp Support (Green icon on your dashboard), Helpline section in the main menu, or email/live chat if available."
    },
    {
      question: "Can I buy shares in global companies like Microsoft?",
      answer: "Yes. Global Equity Finance gives you access to global markets. You can purchase shares in companies like Microsoft (MSFT), Apple, Google, and more."
    },
    {
      question: "Are there any fees or charges?",
      answer: "Some transactions may incur small service fees (e.g., currency conversion or withdrawal processing). These are always disclosed before you confirm."
    },
    {
      question: "Is my personal and financial information safe?",
      answer: "Yes. We use secure encryption and data protection measures to keep your information private. Never share your password or verification codes with anyone."
    }
  ];

  const toggleExpanded = (index) => {
    const newExpanded = new Set(expandedFAQItems);
    if (newExpanded.has(index)) {
      newExpanded.delete(index);
    } else {
      newExpanded.add(index);
    }
    setExpandedFAQItems(newExpanded);
  };

  return (
    <div className="ge-faqs-container">
      <div className="ge-faqs-header">
        <div className="ge-faqs-title-section">
          <FaInfoCircle className="ge-faqs-icon" />
          <h1 className="ge-faqs-title">Frequently Asked Questions</h1>
          <p className="ge-faqs-subtitle">Find answers to common questions about Global Equity Finance</p>
        </div>
      </div>

      <div className="ge-faqs-content">
        <div className="ge-faqs-list">
          {faqs.map((faq, index) => (
            <div key={index} className={`ge-faq-item ${expandedFAQItems.has(index) ? 'expanded' : ''}`}>
              <div 
                className="ge-faq-question"
                onClick={() => toggleExpanded(index)}
              >
                <span className="ge-faq-question-text">{faq.question}</span>
                <div className="ge-faq-toggle">
                  {expandedFAQItems.has(index) ? <FaMinus /> : <FaPlus />}
                </div>
              </div>
              <div className="ge-faq-answer">
                <p>{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="ge-terms-section">
          <div className="ge-terms-header">
            <div className="ge-terms-title-wrapper">
              <FaShieldAlt className="ge-terms-icon" />
              <h2 className="ge-terms-title">Terms and Conditions</h2>
            </div>
            <button 
              className="ge-terms-toggle-btn"
              onClick={() => setShowTerms(!showTerms)}
            >
              {showTerms ? 'Hide' : 'View'} Terms
              {showTerms ? <FaMinus /> : <FaPlus />}
            </button>
          </div>

          {showTerms && (
            <div className="ge-terms-content">
              <div className="ge-terms-overview">
                <p>These Terms and Conditions ("Terms") govern your use of the Global Equity Finance investment platform. By registering and using this site, you agree to be bound by the terms below.</p>
              </div>

              <div className="ge-terms-sections">
                <div className="ge-terms-item">
                  <h3>1. Overview of Services</h3>
                  <p>Global Equity Finance is a professional online investment platform allowing users to:</p>
                  <ul>
                    <li>Buy and sell shares of listed companies (e.g., MSFT)</li>
                    <li>Deposit and withdraw funds (in KES or equivalent)</li>
                    <li>Track portfolio value and share earnings</li>
                    <li>View deposit and withdrawal history</li>
                    <li>Get support via chat or WhatsApp</li>
                  </ul>
                </div>

                <div className="ge-terms-item">
                  <h3>2. Eligibility</h3>
                  <p>To use the platform, you must:</p>
                  <ul>
                    <li>Be at least 18 years old</li>
                    <li>Own a valid national ID or passport</li>
                    <li>Have a verifiable mobile number and M-PESA (or equivalent) account</li>
                  </ul>
                </div>

                <div className="ge-terms-item">
                  <h3>3. Account Registration</h3>
                  <p>Users must register and provide accurate personal and financial details. You are responsible for:</p>
                  <ul>
                    <li>Maintaining the security of your login credentials</li>
                    <li>Ensuring the accuracy of your financial transactions</li>
                    <li>Reporting unauthorized access immediately</li>
                  </ul>
                </div>

                <div className="ge-terms-item">
                  <h3>4. Investment Disclaimer</h3>
                  <p>Global Equity Finance offers access to investment opportunities but <strong>does not guarantee profits</strong>. By using the platform, you acknowledge:</p>
                  <ul>
                    <li>Share values can fluctuate based on market conditions</li>
                    <li>Investment decisions are your sole responsibility</li>
                  </ul>
                </div>

                <div className="ge-terms-item">
                  <h3>5. Deposits and Withdrawals</h3>
                  <ul>
                    <li><strong>Deposit:</strong> Funds can be added via the platform using mobile money. Minimum deposit may apply.</li>
                    <li><strong>Withdrawals:</strong> Can be initiated directly from your dashboard. Withdrawal requests are subject to review and may take up to 3 hrs to process.</li>
                    <li><strong>Currency:</strong> All balances are displayed in <strong>KES</strong>, but investments may be in foreign equities (e.g., USD-denominated).</li>
                  </ul>
                </div>

                <div className="ge-terms-item">
                  <h3>6. Fees and Charges</h3>
                  <ul>
                    <li>Global Equity Finance may charge service or transaction fees. These will be clearly stated before any transaction.</li>
                    <li>Exchange rates may apply when converting currencies.</li>
                    <li>Users are responsible for any local tax obligations.</li>
                  </ul>
                </div>

                <div className="ge-terms-item">
                  <h3>7. User Conduct</h3>
                  <p>You agree not to:</p>
                  <ul>
                    <li>Use the platform for fraudulent or illegal activities</li>
                    <li>Manipulate the system or falsify identity/transactions</li>
                    <li>Post or send malicious software or spam via the support channels</li>
                  </ul>
                </div>

                <div className="ge-terms-item">
                  <h3>8. Support and Communication</h3>
                  <p>Support is available via the in-app helpdesk and WhatsApp. Users should:</p>
                  <ul>
                    <li>Communicate respectfully with support staff</li>
                    <li>Provide accurate account details when raising issues</li>
                    <li>Not misuse the support tools for non-service-related queries</li>
                  </ul>
                </div>

                <div className="ge-terms-item">
                  <h3>9. Data Privacy</h3>
                  <p>We collect personal and financial data to provide services securely. Data will not be shared with third parties without your consent, except where required by law.</p>
                </div>

                <div className="ge-terms-item">
                  <h3>10. Platform Security</h3>
                  <p>We use encryption and secure technology to protect user data. However, we cannot guarantee absolute protection from cyber threats. Users are advised to:</p>
                  <ul>
                    <li>Use strong passwords</li>
                    <li>Log out after each session</li>
                    <li>Avoid accessing the platform over unsecured networks</li>
                  </ul>
                </div>

                <div className="ge-terms-item">
                  <h3>11. Termination and Suspension</h3>
                  <p>We reserve the right to suspend or terminate your account if:</p>
                  <ul>
                    <li>Fraudulent or suspicious activity is detected</li>
                    <li>You violate any of these Terms</li>
                    <li>We are required to do so by legal authorities</li>
                  </ul>
                </div>

                <div className="ge-terms-item">
                  <h3>12. Limitation of Liability</h3>
                  <p>Global Equity Finance is not liable for:</p>
                  <ul>
                    <li>Losses resulting from investment decisions</li>
                    <li>Technical delays or system outages</li>
                    <li>Actions of third-party service providers (banks, telcos)</li>
                  </ul>
                </div>

                <div className="ge-terms-item">
                  <h3>13. Amendments</h3>
                  <p>We may revise these Terms from time to time. Users will be notified via email or platform notices. Continued use of the platform constitutes acceptance of the new Terms.</p>
                </div>

                <div className="ge-terms-item">
                  <h3>14. Governing Law</h3>
                  <p>These Terms are governed by the laws of Kenya and applicable international financial regulations. Any disputes shall be resolved through arbitration or in the courts of jurisdiction.</p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const renderLegalDocumentsView = () => {
  // Path to your document image in the project folder
  const documentImagePath = "/document.jpg"; // Update this path to match your actual file
  
  const handleImageLoad = () => {
    setImageLoaded(true);
  };
  
  const openFullscreen = () => {
    setShowFullscreen(true);
  };
  
  const closeFullscreen = () => {
    setShowFullscreen(false);
  };

  return (
    <div className="ge-legal-container">
      <div className="ge-legal-header">
        <div className="ge-legal-title-section">
          <FaShieldAlt className="ge-legal-icon" />
          <h1 className="ge-legal-title">Legal Documents</h1>
          <p className="ge-legal-subtitle">Official company registration and compliance documents</p>
        </div>
      </div>

      <div className="ge-legal-content">
        <div className="ge-legal-intro">
          <div className="ge-legal-intro-card">
            <FaCheckCircle className="ge-legal-intro-icon" />
            <div className="ge-legal-intro-text">
              <h3>Fully Licensed & Compliant</h3>
              <p>Global Equity Finance operates under full legal compliance with all required certifications and licenses.</p>
            </div>
          </div>
        </div>

        <div className="ge-single-document-container">
          <div className="ge-document-wrapper">
            <div className="ge-document-header">
              <div className="ge-document-badge">
                <FaShieldAlt />
                <span>Official Document</span>
              </div>
              <h2 className="ge-document-main-title">Legal Certification</h2>
              <p className="ge-document-description">
                Complete legal documentation and certification for Global Equity Finance
              </p>
            </div>

            <div className="ge-document-image-container">
              {!imageLoaded && (
                <div className="ge-document-loader">
                  <div className="ge-loader-spinner"></div>
                  <span>Loading document...</span>
                </div>
              )}
              
              <img 
                src={documentImagePath}
                alt="Global Equity Finance Legal Document"
                className={`ge-document-image ${imageLoaded ? 'loaded' : ''}`}
                onLoad={handleImageLoad}
                onClick={openFullscreen}
              />
              
              <div className="ge-document-overlay" onClick={openFullscreen}>
                <FaEye className="ge-overlay-icon" />
                <span className="ge-overlay-text">Click to view full document</span>
              </div>
            </div>

            <div className="ge-document-details">
              <div className="ge-detail-item">
                <FaCheckCircle className="ge-detail-icon success" />
                <div className="ge-detail-content">
                  <h4>Certificate of Incorporation</h4>
                  <p>Official company registration with regulatory authorities</p>
                </div>
              </div>
              
              <div className="ge-detail-item">
                <FaCheckCircle className="ge-detail-icon success" />
                <div className="ge-detail-content">
                  <h4>Business License</h4>
                  <p>Valid operating license for financial services</p>
                </div>
              </div>
              
              <div className="ge-detail-item">
                <FaCheckCircle className="ge-detail-icon success" />
                <div className="ge-detail-content">
                  <h4>Tax Compliance</h4>
                  <p>Current tax compliance and good standing certificate</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="ge-legal-notice">
          <div className="ge-notice-content">
            <FaInfoCircle className="ge-notice-icon" />
            <div className="ge-notice-text">
              <h4>Document Verification</h4>
              <p>This document is authentic and verified. For official verification or additional documentation, please contact our support team through the helpline section.</p>
            </div>
          </div>
        </div>
      </div>

      {/* Fullscreen Modal */}
      {showFullscreen && (
        <div className="ge-fullscreen-modal" onClick={closeFullscreen}>
          <div className="ge-fullscreen-content">
            <div className="ge-fullscreen-header">
              <h3>Legal Document - Full View</h3>
              <button className="ge-fullscreen-close" onClick={closeFullscreen}>
                <FaTimes />
              </button>
            </div>
            <div className="ge-fullscreen-body">
              <img 
                src={documentImagePath}
                alt="Global Equity Finance Legal Document - Full View"
                className="ge-fullscreen-image"
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

  const renderDepositView = () => (
  <div className="ge-deposit-container">
    {/* Header */}
    <div className="ge-deposit-header">
      <h2>Deposit</h2>
    </div>
    
    {/* Main Deposit Card */}
    <div className="ge-deposit-card">
      <div className="ge-deposit-icon">
        <FaPlus />
      </div>
      
      <h3>Add Funds to Portfolio</h3>
      <p>Minimum deposit is KES 300</p>
      
      <div className="ge-input-wrapper">
        <span className="ge-currency-label">KES</span>
        <input
          type="number"
          placeholder="300"
          value={depositAmount}
          onChange={(e) => {
            const value = e.target.value;
            setDepositAmount(value);
            if (toastNotification) {
              setToastNotification(null);
            }
          }}
        />
      </div>
      
      <button 
        className="ge-deposit-btn"
        onClick={() => {
          if (!depositAmount || parseFloat(depositAmount) < 300) {
            setToastNotification({ 
              message: 'Minimum deposit is KES 300', 
              type: 'error' 
            });
            return;
          }
          setCurrentView('paymentProcess');
        }}
        disabled={!depositAmount || parseFloat(depositAmount) < 300}
      >
        <FaMobile />
        Continue with M-Pesa
      </button>
    </div>
    
    {/* Quick Info */}
    <div className="ge-deposit-info">
      <div className="ge-info-header">
        <FaInfoCircle />
        <span>Deposit Information</span>
      </div>
      <div className="ge-info-list">
        <div className="ge-info-item">
          <FaCheckCircle />
          <span>Deposits are processed instantly via mobile money</span>
        </div>
        <div className="ge-info-item">
          <FaCheckCircle />
          <span>Secure & encrypted transactions</span>
        </div>
        <div className="ge-info-item">
          <FaCheckCircle />
          <span>Ready to invest immediately</span>
        </div>
      </div>
    </div>

    <style jsx>{`
      .ge-deposit-container {
        padding: 16px;
        max-width: 400px;
        margin: 0 auto;
        font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
        min-height: 100vh;
        background: linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%);
      }

      .ge-deposit-header {
        display: flex;
        align-items: center;
        gap: 16px;
        margin-bottom: 24px;
      }

      .ge-back-btn {
        width: 44px;
        height: 44px;
        background: rgba(23, 42, 69, 0.8);
        border: 1px solid rgba(231, 76, 60, 0.3);
        border-radius: 12px;
        color: #e74c3c;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: all 0.3s ease;
        border: none;
        font-size: 18px;
      }

      .ge-back-btn:hover {
        background: rgba(231, 76, 60, 0.1);
        transform: translateY(-2px);
      }

      .ge-deposit-header h2 {
        font-size: 24px;
        font-weight: 700;
        color: white;
        margin: 0;
      }

      .ge-deposit-card {
        background: rgba(23, 42, 69, 0.9);
        backdrop-filter: blur(10px);
        border: 1px solid rgba(231, 76, 60, 0.2);
        border-radius: 20px;
        padding: 32px 24px;
        margin-bottom: 20px;
        text-align: center;
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
      }

      .ge-deposit-icon {
        width: 64px;
        height: 64px;
        background: linear-gradient(135deg, #e74c3c, #c0392b);
        border-radius: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        font-size: 28px;
        margin: 0 auto 20px auto;
        box-shadow: 0 8px 24px rgba(231, 76, 60, 0.4);
      }

      .ge-deposit-card h3 {
        font-size: 22px;
        font-weight: 700;
        color: white;
        margin: 0 0 8px 0;
      }

      .ge-deposit-card p {
        color: #8892b0;
        margin: 0 0 24px 0;
        font-size: 14px;
      }

      .ge-input-wrapper {
        display: flex;
        background: rgba(16, 20, 31, 0.8);
        border: 2px solid rgba(231, 76, 60, 0.2);
        border-radius: 16px;
        overflow: hidden;
        margin-bottom: 24px;
        transition: all 0.3s ease;
      }

      .ge-input-wrapper:focus-within {
        border-color: #e74c3c;
        box-shadow: 0 0 0 4px rgba(231, 76, 60, 0.1);
        transform: translateY(-2px);
      }

      .ge-currency-label {
        background: rgba(231, 76, 60, 0.1);
        color: #e74c3c;
        padding: 18px 20px;
        font-weight: 700;
        font-size: 16px;
        border-right: 1px solid rgba(231, 76, 60, 0.2);
      }

      .ge-input-wrapper input {
        flex: 1;
        background: transparent;
        border: none;
        padding: 18px 20px;
        color: white;
        font-size: 20px;
        font-weight: 600;
        outline: none;
      }

      .ge-input-wrapper input::placeholder {
        color: #8892b0;
      }

      .ge-deposit-btn {
        width: 100%;
        background: linear-gradient(135deg, #e74c3c, #c0392b);
        color: white;
        border: none;
        border-radius: 16px;
        padding: 18px;
        font-size: 16px;
        font-weight: 700;
        cursor: pointer;
        transition: all 0.3s ease;
        box-shadow: 0 6px 20px rgba(231, 76, 60, 0.3);
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 10px;
      }

      .ge-deposit-btn:hover:not(:disabled) {
        transform: translateY(-3px);
        box-shadow: 0 8px 25px rgba(231, 76, 60, 0.4);
      }

      .ge-deposit-btn:disabled {
        background: rgba(136, 146, 176, 0.2);
        color: rgba(136, 146, 176, 0.6);
        cursor: not-allowed;
        transform: none;
        box-shadow: none;
      }

      .ge-deposit-info {
        background: rgba(23, 42, 69, 0.6);
        border: 1px solid rgba(231, 76, 60, 0.15);
        border-radius: 16px;
        padding: 20px;
      }

      .ge-info-header {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-bottom: 16px;
        color: #e74c3c;
        font-weight: 600;
        font-size: 16px;
      }

      .ge-info-list {
        display: flex;
        flex-direction: column;
        gap: 12px;
      }

      .ge-info-item {
        display: flex;
        align-items: center;
        gap: 12px;
        color: #8892b0;
        font-size: 14px;
      }

      .ge-info-item svg {
        color: #2ecc71;
        font-size: 16px;
        flex-shrink: 0;
      }

      /* Mobile responsiveness */
      @media (max-width: 480px) {
        .ge-deposit-container {
          padding: 12px;
        }

        .ge-deposit-header h2 {
          font-size: 20px;
        }

        .ge-deposit-card {
          padding: 24px 20px;
        }

        .ge-deposit-icon {
          width: 56px;
          height: 56px;
          font-size: 24px;
        }

        .ge-deposit-card h3 {
          font-size: 20px;
        }

        .ge-input-wrapper input {
          font-size: 18px;
        }
      }

      @media (max-width: 360px) {
        .ge-currency-label {
          padding: 16px 18px;
          font-size: 14px;
        }

        .ge-input-wrapper input {
          padding: 16px 18px;
          font-size: 16px;
        }

        .ge-deposit-btn {
          padding: 16px;
          font-size: 15px;
        }
      }
    `}</style>
  </div>
);

  const SuperLoginBanner = () => {
    if (!isSuperLogin) return null;
    return (
      <div style={styles.superLoginBanner}>
        <div style={styles.superLoginText}>
          <FaUserShield /> Admin Super Login Mode
        </div>
        <button 
          style={styles.superLoginButton}
          onClick={exitSuperLogin}
        >
          Exit Super Login
        </button>
      </div>
    );
  };

  const renderChartSection = () => {
    const chartData = generateChartData(chartTimeframe, selectedCrypto);
    const currentPrice = cryptoPrices[selectedCrypto].price;
    const priceChange = cryptoPrices[selectedCrypto].change;
    const isPriceUp = priceChange >= 0;
    
    return (
      <div className="forex-chart-container">
        <div className="forex-chart-header">
          <div className="forex-coin-selector-wrapper">
            <div className="forex-selected-coin">
              <div className="forex-selected-coin-icon">
                {getCryptoIcon(selectedCrypto)}
              </div>
              <div className="forex-selected-coin-price">
                <div className="forex-price-value">
                  ${currentPrice.toLocaleString('en-US', {maximumFractionDigits: 2})}
                </div>
                <div className={`forex-price-change ${isPriceUp ? 'positive' : 'negative'}`}>
                  {isPriceUp ? '↑' : '↓'} {Math.abs(priceChange).toFixed(2)}%
                </div>
              </div>
            </div>
            
            <div className="forex-coin-dropdown">
              {Object.keys(cryptoPrices).map(crypto => (
                <div 
                  key={crypto}
                  className={`forex-coin-option ${selectedCrypto === crypto ? 'active' : ''}`}
                  onClick={() => setSelectedCrypto(crypto)}
                >
                  <div className="forex-option-icon">
                    {getCryptoIcon(crypto)}
                  </div>
                  <span className="forex-option-symbol">{crypto}</span>
                  <span className={`forex-option-change ${cryptoPrices[crypto].change >= 0 ? 'positive' : 'negative'}`}>
                    {cryptoPrices[crypto].change >= 0 ? '+' : ''}{cryptoPrices[crypto].change.toFixed(1)}%
                  </span>
                </div>
              ))}
            </div>
          </div>
          
          <div className="forex-timeframe-selector">
            {['1H', '1D', '1W', '1M', '1Y'].map(tf => (
              <button
                key={tf}
                className={`forex-timeframe-btn ${chartTimeframe === tf ? 'active' : ''}`}
                onClick={() => setChartTimeframe(tf)}
              >
                {tf}
              </button>
            ))}
          </div>
        </div>
        
        <div className="forex-chart-body">
          <ResponsiveContainer width="100%" height="100%">
            <AreaChart data={chartData}>
              <defs>
                <linearGradient id="colorPrice" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor={isPriceUp ? "#D4AF37" : "#E64545"} stopOpacity={0.3}/>
                  <stop offset="95%" stopColor={isPriceUp ? "#D4AF37" : "#E64545"} stopOpacity={0}/>
                </linearGradient>
              </defs>
              <CartesianGrid strokeDasharray="3 3" stroke="rgba(212, 175, 55, 0.1)" />
              <XAxis 
                dataKey="time" 
                tick={{fill: '#94A3B8'}}
                axisLine={{stroke: 'rgba(212, 175, 55, 0.2)'}}
                tickLine={{stroke: 'rgba(212, 175, 55, 0.2)'}}
              />
              <YAxis 
                domain={['auto', 'auto']}
                tick={{fill: '#94A3B8'}}
                axisLine={{stroke: 'rgba(212, 175, 55, 0.2)'}}
                tickLine={{stroke: 'rgba(212, 175, 55, 0.2)'}}
                tickFormatter={value => `$${value.toLocaleString('en-US', {maximumFractionDigits: 0})}`}
              />
              <Tooltip 
                contentStyle={{
                  backgroundColor: 'rgba(10, 17, 40, 0.95)',
                  borderColor: 'rgba(212, 175, 55, 0.4)',
                  color: '#F8FAFC',
                  borderRadius: '8px',
                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)'
                }}
                labelStyle={{color: '#D4AF37'}}
                formatter={value => [
                  `$${value.toLocaleString('en-US', {maximumFractionDigits: 2})}`, 
                  'Price'
                ]}
              />
              <Area 
                type="monotone" 
                dataKey="price" 
                stroke={isPriceUp ? "#D4AF37" : "#E64545"} 
                strokeWidth={2}
                fillOpacity={0.6}
                fill="url(#colorPrice)" 
                activeDot={{ r: 5, stroke: '#0A1128', strokeWidth: 2, fill: isPriceUp ? "#D4AF37" : "#E64545" }}
              />
              <ReferenceLine 
                y={currentPrice} 
                stroke={isPriceUp ? "rgba(212, 175, 55, 0.6)" : "rgba(230, 69, 69, 0.6)"} 
                strokeDasharray="3 3" 
                isFront={true}
              />
            </AreaChart>
          </ResponsiveContainer>
        </div>
        
        <div className="forex-chart-footer">
          <div className="forex-chart-stats">
            <div className="forex-stat">
              <span className="forex-stat-label">24h High</span>
              <span className="forex-stat-value">${(currentPrice * 1.03).toLocaleString('en-US', {maximumFractionDigits: 0})}</span>
            </div>
            <div className="forex-stat">
              <span className="forex-stat-label">24h Low</span>
              <span className="forex-stat-value">${(currentPrice * 0.97).toLocaleString('en-US', {maximumFractionDigits: 0})}</span>
            </div>
            <div className="forex-stat">
              <span className="forex-stat-label">Volume</span>
              <span className="forex-stat-value">$2.8B</span>
            </div>
          </div>
          <span className="forex-last-updated">Updated {new Date().toLocaleTimeString()}</span>
        </div>
      </div>
    );
  };

  const renderMainView = () => (
    <div className="forex-pesa-home-page-main-container">
      <div className="global-equity-header">
        <div className="ge-header-main">
          {/* Left side - Logo */}
          <div className="ge-brand-section">
            <div className="ge-logo-container">
              <FaGlobe className="ge-globe-icon" />
              <div className="ge-brand-text">
                <span className="ge-brand-name">
                  Global<span className="ge-equity-text">Equity</span>
                </span>
                <span className="ge-brand-tagline">Investment Platform</span>
              </div>
            </div>
          </div>

          {/* Right side - User Profile */}
          <div className="ge-user-section">
            <div className="ge-greeting-text">
              <span className="ge-greeting">{getTimeBasedGreeting()}</span>
              <span className="ge-user-name">{userDetails?.fullName?.split(' ')[0] || 'User'}</span>
            </div>
            <div className="ge-user-avatar">
              <span className="ge-avatar-letter">
                {userDetails?.fullName?.charAt(0).toUpperCase() || 'U'}
              </span>
              <div className="ge-status-indicator"></div>
            </div>
          </div>
        </div>

        {/* Background decorations */}
        <div className="ge-header-decoration">
          <div className="ge-decoration-circle ge-circle-1"></div>
          <div className="ge-decoration-circle ge-circle-2"></div>
          <div className="ge-decoration-circle ge-circle-3"></div>
        </div>
      </div>
      
            <div className="ge-wallet-card">
          <div className="ge-wallet-content">
            <div className="ge-wallet-header">
              <div className="ge-balance-info">
                <span className="ge-balance-label">Balance</span>
                <div className="ge-balance-amount">
                  <span className="ge-currency">KES</span>
                  <span className="ge-amount">{calculateTotalBalance()}</span>
                </div>
              </div>
              <div className="ge-security-badge">
                <FaShieldAlt />
              </div>
            </div>
            
            <div className="ge-wallet-actions">
              <button 
                className="ge-action-btn ge-deposit-btn"
                onClick={() => setCurrentView('deposit')}
              >
                <FaPlus />
                <span>Deposit</span>
              </button>
              
              <button 
                className="ge-action-btn ge-withdraw-btn"
                onClick={() => setCurrentView('cashout')}
              >
                <FaMinus />
                <span>Withdraw</span>
              </button>
            </div>
          </div>
        </div>

         <LiveTransactionsBot />
      
      <div className="forex-pesa-home-page-main-section-header">
        <div className="forex-pesa-home-page-main-section-icon">
          <FaDatabase />
        </div>
        <h2 className="forex-pesa-home-page-main-section-title">Menu</h2>
      </div>
      
      <div className="forex-pesa-home-page-main-features-grid">
        {features.map((feature, index) => (
          <div 
            key={index} 
            className="forex-pesa-home-page-main-feature-item"
            onClick={() => setCurrentView(feature.view)}
          >
            
            <p className="forex-pesa-home-page-main-feature-label">{feature.name}</p>
          </div>
        ))}

      </div>
      
      <CompanyShares />

    </div>
  );

  const renderView = () => {
    switch (currentView) {
      case 'deposit':
        return renderDepositView();
      case 'paymentProcess':
        return renderPaymentProcessView();
      case 'paymentSuccess':
        return renderPaymentSuccessView();
      case 'cashout':
        return renderCashoutView();
      case 'mydeposit':
        return renderDepositRecord();
      case 'withdrawal':
        return renderWithdrawalRecord();
      case 'customer':
        return renderCustomerService();
      case 'about':
        return renderAboutUs();
      case 'investmentSuccess':
        return renderInvestmentSuccessView();
      case 'faqs':  // Add this case
        return renderFAQsView();
      case 'documents':  // Add this case
        return renderLegalDocumentsView();
      case 'mining':
        return (
            <div style={{padding: '16px'}}>
              <h2 style={{
                fontSize: '20px',
                fontWeight: '600',
                color: '#F8FAFC',
                marginBottom: '16px'
              }}>
                Mining Packages
              </h2>
              
              <div className="income-guide-banner">
                <div className="income-guide-content">
                  <div className="income-guide-icon">
                    <FaLightbulb style={{ fontSize: '24px', color: '#FFD700' }} />
                  </div>
                  <div className="income-guide-text">
                    <h3 className="income-guide-title">Ready to Generate Income?</h3>
                    <p className="income-guide-description">
                      Click on <strong>Invest</strong> in the bottom navigation to activate your profit engines and start generating mining income!
                    </p>
                  </div>
                </div>
                <div className="income-guide-arrow">
                  <FaArrowDown style={{ fontSize: '20px', color: '#38BDF8' }} />
                </div>
              </div>
              
              <style jsx>{`
                .income-guide-banner {
                  background: linear-gradient(135deg, #0F172A 0%, #1E293B 100%);
                  border-radius: 12px;
                  margin: 0 0 20px 0;
                  padding: 16px;
                  border: 1px solid #334155;
                  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
                  position: relative;
                  overflow: hidden;
                }
                
                .income-guide-banner::before {
                  content: '';
                  position: absolute;
                  top: 0;
                  right: 0;
                  width: 120px;
                  height: 120px;
                  background: radial-gradient(circle, rgba(56, 189, 248, 0.1) 0%, rgba(56, 189, 248, 0) 70%);
                  border-radius: 50%;
                }
                
                .income-guide-content {
                  display: flex;
                  align-items: center;
                }
                
                .income-guide-icon {
                  background-color: rgba(255, 215, 0, 0.1);
                  border-radius: 50%;
                  width: 50px;
                  height: 50px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  margin-right: 16px;
                  flex-shrink: 0;
                }
                
                .income-guide-text {
                  flex: 1;
                }
                
                .income-guide-title {
                  font-size: 18px;
                  font-weight: 600;
                  color: #F8FAFC;
                  margin: 0 0 4px 0;
                }
                
                .income-guide-description {
                  font-size: 14px;
                  color: #94A3B8;
                  margin: 0;
                  line-height: 1.4;
                }
                
                .income-guide-description strong {
                  color: #38BDF8;
                  font-weight: 600;
                }
                
                .income-guide-arrow {
                  display: flex;
                  justify-content: center;
                  margin-top: 12px;
                  animation: bounceArrow 2s infinite ease-in-out;
                }
                
                @keyframes bounceArrow {
                  0%, 100% {
                    transform: translateY(0);
                  }
                  50% {
                    transform: translateY(8px);
                  }
                }
              `}</style>
            </div>
          );
      default:
        return renderMainView();
    }
  };

  return (
    <div style={styles.container}>
      <SuperLoginBanner />
      
      {currentView !== 'main' && (
        <button 
          style={styles.backButton}
          onClick={() => setCurrentView('main')}
        >
          <FaArrowLeft /> Back
        </button>
      )}
      
      {renderView()}
      
      {showInvestmentDialog && selectedProduct && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000,
          padding: '16px'
        }}>
          <div style={{
            backgroundColor: '#1E293B',
            borderRadius: '16px',
            width: '100%',
            maxWidth: '400px',
            overflow: 'hidden',
            boxShadow: '0 10px 25px rgba(0, 0, 0, 0.5)'
          }}>
            <div style={{
              padding: '16px',
              borderBottom: '1px solid #334155',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}>
              <h3 style={{
                fontSize: '18px',
                fontWeight: '600',
                color: '#F8FAFC'
              }}>
                Start Mining
              </h3>
              <button 
                style={{
                  backgroundColor: 'transparent',
                  border: 'none',
                  color: '#94A3B8',
                  fontSize: '20px',
                  cursor: 'pointer'
                }}
                onClick={handleCloseInvestmentDialog}
              >
                <FaTimes />
              </button>
            </div>
            
            <div style={{padding: '16px'}}>
              <h4 style={{
                fontSize: '16px',
                fontWeight: '600',
                color: '#F8FAFC',
                marginBottom: '16px'
              }}>
                {selectedProduct.name}
              </h4>
              
              <div style={{marginBottom: '16px'}}>
                <div style={{
                  fontSize: '14px',
                  color: '#94A3B8',
                  marginBottom: '8px'
                }}>
                  Select quantity:
                </div>
                <div style={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: '8px'
                }}>
                  {[...Array(Math.min(selectedProduct.available, 6))].map((_, index) => (
                    <button
                      key={index + 1}
                      style={{
                        flex: '1 0 calc(33.333% - 8px)',
                        padding: '12px 0',
                        backgroundColor: quantity === index + 1 ? '#2563EB' : '#334155',
                        border: 'none',
                        borderRadius: '8px',
                        color: quantity === index + 1 ? 'white' : '#E2E8F0',
                        fontSize: '16px',
                        cursor: 'pointer'
                      }}
                      onClick={() => handleQuantityChange(index + 1)}
                    >
                      {index + 1}
                    </button>
                  ))}
                </div>
              </div>
              
              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                padding: '12px 0',
                borderBottom: '1px solid #334155'
              }}>
                <span style={{color: '#94A3B8'}}>Daily Yield</span>
                <span style={{color: '#F8FAFC', fontWeight: '500'}}>
                  KES {selectedProduct.dailyIncome * quantity}
                </span>
              </div>
              
              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                padding: '12px 0',
                borderBottom: '1px solid #334155'
              }}>
                <span style={{color: '#94A3B8'}}>Total Return</span>
                <span style={{color: '#F8FAFC', fontWeight: '500'}}>
                  KES {selectedProduct.totalIncome * quantity}
                </span>
              </div>
              
              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                padding: '12px 0',
                borderBottom: '1px solid #334155'
              }}>
                <span style={{color: '#94A3B8'}}>Available</span>
                <span style={{color: '#F8FAFC', fontWeight: '500'}}>
                  {selectedProduct.available} units
                </span>
              </div>
              
              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                padding: '12px 0',
                marginBottom: '16px'
              }}>
                <span style={{color: '#94A3B8'}}>Total Investment</span>
                <span style={{color: '#38BDF8', fontWeight: '700'}}>
                  KES {selectedProduct.price * quantity}
                </span>
              </div>
              
              <button 
                style={{
                  width: '100%',
                  backgroundColor: '#2563EB',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  padding: '14px',
                  fontSize: '16px',
                  fontWeight: '600',
                  cursor: 'pointer'
                }}
                onClick={handleInvestNow}
              >
                CONFIRM MINING OPERATION
              </button>
            </div>
          </div>
        </div>
      )}
      
   {showPopup && (
  <div className="welcome-popup">
    <div className="popup-container">
      <div className="popup-header">
        <FaGlobe className="logo-icon" />
        <h2>Welcome to <span>GlobalEquity</span></h2>
        <p>Getting Started</p>
      </div>

      <div className="popup-content">
        <p><strong>1. Register & Log In</strong><br />Create your account to access your personal dashboard.</p>
        <p><strong>2. Fund Your Wallet</strong><br />Deposit the amount you wish to invest.</p>
        <p><strong>3. Explore Investments</strong><br />Browse our available investment packages.</p>
        <p><strong>4. Select a Package</strong><br />Choose a plan that fits your budget and goals.</p>
        <p><strong>5. Confirm Your Investment</strong><br />Activate your package to begin earning.</p>
        <p><strong>6. Track Your Earnings</strong><br />Monitor your portfolio anytime from your dashboard.</p>
        <p><strong>7. Withdraw at Maturity</strong><br />Access your capital and profits once your investment matures.</p>
        <p>Invest with confidence. Grow with consistency.</p>
      </div>

      <div className="popup-actions">
        <button
          className="whatsapp-button"
          onClick={joinTelegramChannel}
        >
          <FaWhatsapp />
          Join WhatsApp Community
        </button>
      </div>

      <button
        className="close-button"
        onClick={() => setShowPopup(false)}
      >
        <FaTimes />
      </button>
    </div>
  </div>
)}
      
      <BottomNavigation />
      
      {toastNotification && (
  <div className={`toast-notification ${toastNotification.isExiting ? 'exiting' : ''}`}>
    <div className="toast-icon">
      {toastNotification.type === 'success' ? (
        <FaCheckCircle className="success-icon" />
      ) : (
        <FaTimes className="error-icon" />
      )}
    </div>
    <div className="toast-content">
      <div className="toast-title">
        {toastNotification.type === 'success' ? 'Success' : 'Error'}
      </div>
      <div className="toast-message">{toastNotification.message}</div>
    </div>
    <button className="toast-close" onClick={() => handleCloseToast()}>
      <FaTimes className="close-icon" />
    </button>
    <style jsx>{`
      .toast-notification {
        position: fixed;
        bottom: 24px;
        right: 24px;
        display: flex;
        align-items: center;
        padding: 12px 16px;
        border-radius: 8px;
        box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
        max-width: 350px;
        background-color: ${toastNotification.type === 'success' ? '#ecfdf5' : '#fef2f2'};
        border-left: 4px solid ${toastNotification.type === 'success' ? '#10B981' : '#EF4444'};
        z-index: 9999;
        animation: slideIn 0.4s ease-out forwards;
        transition: all 0.3s ease-in-out;
      }
      
      .toast-notification.exiting {
        animation: slideOut 0.4s ease-out forwards;
      }
      
      .toast-icon {
        padding: 8px;
        border-radius: 50%;
        background-color: ${toastNotification.type === 'success' 
          ? 'rgba(16, 185, 129, 0.1)' 
          : 'rgba(239, 68, 68, 0.1)'};
        margin-right: 12px;
      }
      
      .success-icon {
        color: #10B981;
        font-size: 20px;
      }
      
      .error-icon {
        color: #EF4444;
        font-size: 20px;
      }
      
      .toast-content {
        flex: 1;
        font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
      }
      
      .toast-title {
        font-weight: 600;
        margin-bottom: 2px;
        color: ${toastNotification.type === 'success' ? '#065f46' : '#991b1b'};
      }
      
      .toast-message {
        font-size: 14px;
        color: ${toastNotification.type === 'success' ? '#065f46' : '#991b1b'};
        opacity: 0.9;
      }
      
      .toast-close {
        background: transparent;
        border: none;
        cursor: pointer;
        padding: 4px;
        margin-left: 8px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        opacity: 0.6;
        transition: opacity 0.2s ease-in-out;
      }
      
      .toast-close:hover {
        opacity: 1;
      }
      
      .close-icon {
        font-size: 12px;
        color: ${toastNotification.type === 'success' ? '#065f46' : '#991b1b'};
      }
      
      @keyframes slideIn {
        0% {
          transform: translateX(100%);
          opacity: 0;
        }
        100% {
          transform: translateX(0);
          opacity: 1;
        }
      }
      
      @keyframes slideOut {
        0% {
          transform: translateX(0);
          opacity: 1;
        }
        100% {
          transform: translateX(100%);
          opacity: 0;
        }
      }
    `}</style>
  </div>
)}
      
      <style jsx>{`

      /* Main container and header styles */
.forex-pesa-home-page-main-container {
  position: relative;
}

.forex-pesa-home-page-main-header {
  background: linear-gradient(145deg, rgba(10, 17, 40, 0.95), rgba(5, 7, 15, 0.98));
  padding: 24px 20px;
  border-bottom: 1px solid rgba(212, 175, 55, 0.2);
  position: relative;
  overflow: hidden;
  border-radius: 0 0 20px 20px;
  margin-bottom: 5px;
}

.forex-pesa-home-page-main-header-content {
  position: relative;
  z-index: 2;
}

.forex-pesa-home-page-main-header-decoration {
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.forex-pesa-home-page-main-decoration-circle {
  position: absolute;
  border-radius: 50%;
  background: linear-gradient(135deg, rgba(212, 175, 55, 0.1), rgba(212, 175, 55, 0.02));
}

.forex-pesa-home-page-main-decoration-circle:nth-child(1) {
  width: 200px;
  height: 200px;
  top: -100px;
  right: -70px;
}

.forex-pesa-home-page-main-decoration-circle:nth-child(2) {
  width: 150px;
  height: 150px;
  bottom: -50px;
  right: 20%;
  opacity: 0.5;
}


.forex-pesa-home-page-main-user-avatar {
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, #D4AF37, #996515);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: #0A1128;
  margin-right: 14px;
  position: relative;
  box-shadow: 0 4px 12px rgba(212, 175, 55, 0.3);
}


.forex-pesa-home-page-main-header-icon {
  font-size: 16px;
}

.forex-pesa-home-page-main-notifications-list {
  max-height: 300px;
  overflow-y: auto;
}

.forex-pesa-home-page-main-notification-item {
  padding: 14px 16px;
  border-bottom: 1px solid rgba(212, 175, 55, 0.05);
  cursor: pointer;
  transition: background 0.2s ease;
}

.forex-pesa-home-page-main-notification-item:hover {
  background: rgba(212, 175, 55, 0.05);
}

.forex-pesa-home-page-main-notification-item.forex-pesa-home-page-main-unread {
  background: rgba(212, 175, 55, 0.08);
  position: relative;
}

.forex-pesa-home-page-main-notification-item.forex-pesa-home-page-main-unread::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 3px;
  background: #D4AF37;
}

.forex-pesa-home-page-main-notification-message {
  font-size: 14px;
  color: #E2E8F0;
  margin-bottom: 6px;
  line-height: 1.4;
}

.forex-pesa-home-page-main-notification-time {
  font-size: 12px;
  color: #94A3B8;
}

.forex-pesa-home-page-main-no-notifications {
  padding: 20px;
  text-align: center;
  color: #94A3B8;
  font-size: 14px;
}


.forex-pesa-home-page-main-wallet-content {
  flex: 1;
  position: relative;
  z-index: 1;
}

.forex-pesa-home-page-main-wallet-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.forex-pesa-home-page-main-wallet-title {
  font-size: 14px;
  color: #A0A0A0;
}

.forex-pesa-home-page-main-wallet-badge {
  font-size: 11px;
  font-weight: 600;
  color: #D4AF37;
  background: rgba(212, 175, 55, 0.1);
  padding: 4px 10px;
  border-radius: 10px;
  border: 1px solid rgba(212, 175, 55, 0.2);
}

.forex-pesa-home-page-main-wallet-amount {
  font-size: 36px;
  font-weight: 700;
  margin-bottom: 20px;
  color: #FFFFFF;
  position: relative;
}

.forex-pesa-home-page-main-wallet-amount::after {
  content: '';
  position: absolute;
  width: 60px;
  height: 60px;
  background: radial-gradient(circle, rgba(212, 175, 55, 0.2), transparent 70%);
  top: -15px;
  left: -15px;
  z-index: -1;
  opacity: 0.7;
}

.forex-pesa-home-page-main-currency-symbol {
  font-size: 24px;
  color: #D4AF37;
  margin-right: 5px;
}

.forex-pesa-home-page-main-wallet-actions {
  display: flex;
  gap: 12px;
}

.forex-pesa-home-page-main-button {
  flex: 1;
  position: relative;
  border: none;
  border-radius: 12px;
  padding: 0;
  font-size: 15px;
  font-weight: 600;
  height: 46px;
  cursor: pointer;
  overflow: hidden;
  transition: all 0.3s ease;
}

.forex-pesa-home-page-main-button:hover {
  transform: translateY(-3px);
}

.forex-pesa-home-page-main-button-content {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  height: 100%;
  z-index: 2;
}

.forex-pesa-home-page-main-deposit-button {
  background: linear-gradient(135deg, #D4AF37, #996515);
  color: #0A1128;
  box-shadow: 0 4px 12px rgba(153, 101, 21, 0.3);
}

.forex-pesa-home-page-main-withdraw-button {
  background: rgba(212, 175, 55, 0.12);
  color: #D4AF37;
  border: 1px solid rgba(212, 175, 55, 0.3);
}

.forex-pesa-home-page-main-button-icon {
  font-size: 16px;
}

.forex-pesa-home-page-main-button-shine {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    to right,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.2) 50%,
    rgba(255, 255, 255, 0) 100%
  );
  transform: translateX(-100%);
  animation: buttonShine 3s infinite;
}

.forex-pesa-home-page-main-wallet-decoration {
  position: absolute;
  top: 0;
  right: 0;
  width: 100px;
  height: 100%;
  z-index: 1;
}

.forex-pesa-home-page-main-crypto-badges {
  position: absolute;
  top: 50%;
  right: 25px;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.forex-pesa-home-page-main-crypto-badge {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: white;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
  border: 2px solid rgba(5, 7, 15, 0.7);
  transition: all 0.3s ease;
}

.forex-pesa-home-page-main-crypto-badge:hover {
  transform: scale(1.1);
}

.forex-pesa-home-page-main-badge-btc {
  background-color: #F7931A;
}

.forex-pesa-home-page-main-badge-eth {
  background-color: #627EEA;
}

.forex-pesa-home-page-main-badge-xrp {
  background-color: #0066B1;
}

/* Crypto selector styles */
.forex-pesa-home-page-main-crypto-selector {
  display: flex;
  gap: 12px;
  padding: 0 20px;
  margin-bottom: 24px;
  overflow-x: auto;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  scroll-behavior: smooth;
}

.forex-pesa-home-page-main-crypto-selector::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Opera */
}

.forex-pesa-home-page-main-crypto-option {
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: rgba(10, 17, 40, 0.6);
  border: 1px solid rgba(212, 175, 55, 0.15);
  border-radius: 16px;
  padding: 16px;
  min-width: 120px;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.forex-pesa-home-page-main-crypto-option::before {
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: linear-gradient(135deg, rgba(212, 175, 55, 0.05), transparent 70%);
  z-index: 0;
}

.forex-pesa-home-page-main-crypto-option.forex-pesa-home-page-main-active {
  background: rgba(212, 175, 55, 0.12);
  border-color: rgba(212, 175, 55, 0.4);
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
}

.forex-pesa-home-page-main-crypto-icon {
  font-size: 28px;
  margin-bottom: 12px;
  position: relative;
  z-index: 1;
}

.forex-pesa-home-page-main-crypto-details {
  width: 100%;
  position: relative;
  z-index: 1;
}

.forex-pesa-home-page-main-crypto-name {
  font-size: 16px;
  font-weight: 600;
  text-align: center;
  margin-bottom: 8px;
  color: #FFFFFF;
}

.forex-pesa-home-page-main-crypto-price {
  font-size: 14px;
  text-align: center;
  color: #A0A0A0;
  margin-bottom: 8px;
}

.forex-pesa-home-page-main-crypto-change {
  font-size: 13px;
  font-weight: 600;
  text-align: center;
  padding: 4px 8px;
  border-radius: 8px;
  width: 80%;
  margin: 0 auto;
}

.forex-pesa-home-page-main-crypto-change.positive {
  background: rgba(76, 175, 80, 0.1);
  color: #4CAF50;
}

.forex-pesa-home-page-main-crypto-change.negative {
  background: rgba(244, 67, 54, 0.1);
  color: #F44336;
}

/* Section header styles */
.forex-pesa-home-page-main-section-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0 20px 16px;
  position: relative;
}

.forex-pesa-home-page-main-section-header::after {
  content: '';
  position: absolute;
  bottom: -6px;
  left: 0;
  width: 60px;
  height: 2px;
  background: linear-gradient(to right, rgba(212, 175, 55, 0.7), transparent);
}

.forex-pesa-home-page-main-section-icon {
  width: 36px;
  height: 36px;
  background: rgba(212, 175, 55, 0.1);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #D4AF37;
}

.forex-pesa-home-page-main-section-title {
  font-size: 18px;
  font-weight: 600;
  margin: 0;
  color: #FFFFFF;
}


/* Updated Global Equity Header Styles */
.global-equity-header {
  background: linear-gradient(135deg, rgba(23, 42, 69, 0.95), rgba(16, 20, 31, 0.98));
  border-radius: 20px;
  padding: 16px 20px;
  position: relative;
  overflow: hidden;
  border: 1px solid rgba(231, 76, 60, 0.25);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(10px);
  margin-bottom: 20px;
}

.ge-header-main {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  z-index: 3;
}

/* Left side - Logo */
.ge-brand-section {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
}

.ge-logo-container {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.ge-globe-icon {
  font-size: 28px;
  color: #e74c3c;
  filter: drop-shadow(0 2px 4px rgba(231, 76, 60, 0.3));
  animation: geGlobeRotate 8s linear infinite;
  flex-shrink: 0;
}

@keyframes geGlobeRotate {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.ge-brand-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.ge-brand-name {
  font-size: 22px;
  font-weight: 800;
  color: white;
  line-height: 1;
  letter-spacing: -0.5px;
  white-space: nowrap;
}

.ge-equity-text {
  color: #e74c3c;
}

.ge-brand-tagline {
  font-size: 11px;
  color: #8892b0;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  white-space: nowrap;
}

/* Right side - User Profile */
.ge-user-section {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
}

.ge-greeting-text {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
  min-width: 0;
}

.ge-greeting {
  font-size: 12px;
  color: #8892b0;
  font-weight: 500;
  text-transform: capitalize;
  white-space: nowrap;
}

.ge-user-name {
  font-size: 14px;
  font-weight: 600;
  color: white;
  line-height: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 80px;
}

.ge-user-avatar {
  position: relative;
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, #e74c3c, #c0392b);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(231, 76, 60, 0.3);
  border: 2px solid rgba(255, 255, 255, 0.1);
  flex-shrink: 0;
}

.ge-avatar-letter {
  font-size: 16px;
  font-weight: 700;
  color: white;
  text-transform: uppercase;
}

.ge-status-indicator {
  position: absolute;
  bottom: -2px;
  right: -2px;
  width: 12px;
  height: 12px;
  background: #10b981;
  border-radius: 50%;
  border: 2px solid rgba(23, 42, 69, 0.9);
  animation: geStatusPulse 2s infinite;
}

@keyframes geStatusPulse {
  0%, 100% {
    box-shadow: 0 0 0 0 rgba(16, 185, 129, 0.4);
  }
  50% {
    box-shadow: 0 0 0 4px rgba(16, 185, 129, 0);
  }
}

/* Background decorations */
.ge-header-decoration {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  overflow: hidden;
}

.ge-decoration-circle {
  position: absolute;
  border-radius: 50%;
  background: rgba(231, 76, 60, 0.1);
  animation: geFloatAnimation 6s ease-in-out infinite;
}

.ge-circle-1 {
  width: 60px;
  height: 60px;
  top: -20px;
  right: 40px;
  animation-delay: 0s;
}

.ge-circle-2 {
  width: 40px;
  height: 40px;
  bottom: -10px;
  left: 20px;
  animation-delay: 2s;
}

.ge-circle-3 {
  width: 30px;
  height: 30px;
  top: 50%;
  right: -10px;
  animation-delay: 4s;
}

@keyframes geFloatAnimation {
  0%, 100% {
    transform: translateY(0px) rotate(0deg);
    opacity: 0.3;
  }
  50% {
    transform: translateY(-10px) rotate(180deg);
    opacity: 0.6;
  }
}

/* Tablet responsiveness */
@media (max-width: 768px) {
  .global-equity-header {
    padding: 14px 16px;
    border-radius: 16px;
  }
  
  .ge-logo-container {
    gap: 10px;
  }
  
  .ge-brand-name {
    font-size: 20px;
  }
  
  .ge-globe-icon {
    font-size: 26px;
  }
  
  .ge-brand-tagline {
    font-size: 10px;
  }
  
  .ge-user-section {
    gap: 10px;
  }
  
  .ge-greeting {
    font-size: 11px;
  }
  
  .ge-user-name {
    font-size: 13px;
    max-width: 70px;
  }
  
  .ge-user-avatar {
    width: 38px;
    height: 38px;
  }
  
  .ge-avatar-letter {
    font-size: 15px;
  }
}

/* Mobile responsiveness - Large phones */
@media (max-width: 480px) {
  .global-equity-header {
    padding: 12px 14px;
    border-radius: 14px;
  }
  
  .ge-header-main {
    gap: 8px;
  }
  
  .ge-logo-container {
    gap: 8px;
  }
  
  .ge-brand-name {
    font-size: 18px;
  }
  
  .ge-globe-icon {
    font-size: 24px;
  }
  
  .ge-brand-tagline {
    font-size: 9px;
  }
  
  .ge-user-section {
    gap: 8px;
  }
  
  .ge-greeting {
    font-size: 10px;
  }
  
  .ge-user-name {
    font-size: 12px;
    max-width: 60px;
  }
  
  .ge-user-avatar {
    width: 36px;
    height: 36px;
    border-radius: 10px;
  }
  
  .ge-avatar-letter {
    font-size: 14px;
  }
  
  .ge-status-indicator {
    width: 10px;
    height: 10px;
  }
}

/* Mobile responsiveness - Small phones */
@media (max-width: 360px) {
  .global-equity-header {
    padding: 10px 12px;
  }
  
  .ge-logo-container {
    gap: 6px;
  }
  
  .ge-brand-name {
    font-size: 16px;
  }
  
  .ge-globe-icon {
    font-size: 22px;
  }
  
  .ge-brand-tagline {
    font-size: 8px;
  }
  
  .ge-user-section {
    gap: 6px;
  }
  
  .ge-greeting-text {
    gap: 1px;
  }
  
  .ge-greeting {
    font-size: 9px;
  }
  
  .ge-user-name {
    font-size: 11px;
    max-width: 50px;
  }
  
  .ge-user-avatar {
    width: 32px;
    height: 32px;
    border-radius: 8px;
  }
  
  .ge-avatar-letter {
    font-size: 12px;
  }
  
  .ge-status-indicator {
    width: 8px;
    height: 8px;
    bottom: -1px;
    right: -1px;
  }
  
  /* Reduce decoration circles on very small screens */
  .ge-circle-1 {
    width: 40px;
    height: 40px;
  }
  
  .ge-circle-2 {
    width: 25px;
    height: 25px;
  }
  
  .ge-circle-3 {
    width: 20px;
    height: 20px;
  }
}

/* Extra small screens - Landscape phones */
@media (max-width: 320px) {
  .ge-brand-name {
    font-size: 15px;
  }
  
  .ge-globe-icon {
    font-size: 20px;
  }
  
  .ge-greeting {
    font-size: 8px;
  }
  
  .ge-user-name {
    font-size: 10px;
    max-width: 45px;
  }
  
  .ge-user-avatar {
    width: 30px;
    height: 30px;
  }
  
  .ge-avatar-letter {
    font-size: 11px;
  }
}

/* Global Equity Wallet Styles */
.ge-wallet-card {
  margin: 12px;
  background: linear-gradient(135deg, rgba(23, 42, 69, 0.9), rgba(16, 20, 31, 0.95));
  border-radius: 12px;
  border: 1px solid rgba(231, 76, 60, 0.2);
  overflow: hidden;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}

.ge-wallet-content {
  padding: 16px;
}

.ge-wallet-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 16px;
}

.ge-balance-info {
  flex: 1;
}

.ge-balance-label {
  font-size: 12px;
  font-weight: 500;
  color: #8892b0;
  display: block;
  margin-bottom: 4px;
}

.ge-balance-amount {
  display: flex;
  align-items: baseline;
  gap: 6px;
}

.ge-currency {
  font-size: 14px;
  font-weight: 600;
  color: #e74c3c;
}

.ge-amount {
  font-size: 24px;
  font-weight: 700;
  color: white;
  line-height: 1;
}

/* FAQs Styles */
.ge-faqs-container {
  padding: 20px;
  max-width: 800px;
  margin: 0 auto;
  background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);
  min-height: 100vh;
}

.ge-faqs-header {
  text-align: center;
  margin-bottom: 30px;
  position: relative;
}

.ge-faqs-title-section {
  position: relative;
  z-index: 2;
}

.ge-faqs-icon {
  font-size: 40px;
  color: #e74c3c;
  margin-bottom: 16px;
  filter: drop-shadow(0 0 10px rgba(231, 76, 60, 0.3));
}

.ge-faqs-title {
  font-size: 28px;
  font-weight: 800;
  color: white;
  margin: 0 0 8px 0;
  background: linear-gradient(135deg, #ffffff, #e74c3c);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.ge-faqs-subtitle {
  font-size: 16px;
  color: #94a3b8;
  margin: 0;
}

.ge-faqs-content {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.ge-faqs-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.ge-faq-item {
  background: rgba(23, 42, 69, 0.8);
  border: 1px solid rgba(231, 76, 60, 0.2);
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.ge-faq-item:hover {
  border-color: rgba(231, 76, 60, 0.4);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.ge-faq-question {
  padding: 16px 20px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  user-select: none;
}

.ge-faq-question-text {
  font-size: 16px;
  font-weight: 600;
  color: white;
  flex: 1;
  margin-right: 16px;
}

.ge-faq-toggle {
  width: 32px;
  height: 32px;
  background: rgba(231, 76, 60, 0.1);
  border: 1px solid rgba(231, 76, 60, 0.3);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #e74c3c;
  font-size: 14px;
  transition: all 0.3s ease;
}

.ge-faq-item.expanded .ge-faq-toggle {
  background: rgba(231, 76, 60, 0.2);
  transform: rotate(180deg);
}

.ge-faq-answer {
  max-height: 0;
  overflow: hidden;
  transition: all 0.3s ease;
  background: rgba(16, 20, 31, 0.5);
}

.ge-faq-item.expanded .ge-faq-answer {
  max-height: 500px;
  padding: 16px 20px;
}

.ge-faq-answer p {
  color: #cbd5e1;
  line-height: 1.6;
  margin: 0;
  font-size: 14px;
}

.ge-terms-section {
  background: rgba(23, 42, 69, 0.8);
  border: 1px solid rgba(231, 76, 60, 0.2);
  border-radius: 12px;
  overflow: hidden;
}

.ge-terms-header {
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgba(231, 76, 60, 0.1);
}

.ge-terms-title-wrapper {
  display: flex;
  align-items: center;
  gap: 12px;
}

.ge-terms-icon {
  font-size: 24px;
  color: #e74c3c;
}

.ge-terms-title {
  font-size: 20px;
  font-weight: 700;
  color: white;
  margin: 0;
}

.ge-terms-toggle-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background: rgba(231, 76, 60, 0.1);
  border: 1px solid rgba(231, 76, 60, 0.3);
  border-radius: 8px;
  color: #e74c3c;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.ge-terms-toggle-btn:hover {
  background: rgba(231, 76, 60, 0.2);
  transform: translateY(-1px);
}

.ge-terms-content {
  padding: 20px;
  background: rgba(16, 20, 31, 0.3);
}

.ge-terms-overview {
  margin-bottom: 24px;
  padding: 16px;
  background: rgba(231, 76, 60, 0.05);
  border-left: 4px solid #e74c3c;
  border-radius: 4px;
}

.ge-terms-overview p {
  color: #cbd5e1;
  margin: 0;
  font-size: 14px;
  line-height: 1.6;
}

.ge-terms-sections {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.ge-terms-item {
  background: rgba(23, 42, 69, 0.4);
  padding: 20px;
  border-radius: 8px;
  border: 1px solid rgba(231, 76, 60, 0.1);
}

.ge-terms-item h3 {
  color: #e74c3c;
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 12px 0;
}

.ge-terms-item p {
  color: #cbd5e1;
  margin: 0 0 12px 0;
  line-height: 1.6;
  font-size: 14px;
}

.ge-terms-item ul {
  margin: 0;
  padding-left: 20px;
  color: #cbd5e1;
}

.ge-terms-item li {
  margin-bottom: 8px;
  line-height: 1.5;
  font-size: 14px;
}

.ge-terms-item strong {
  color: white;
  font-weight: 600;
}

/* Legal Documents Styles */
.ge-legal-container {
  padding: 20px;
  max-width: 1000px;
  margin: 0 auto;
  background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);
  min-height: 100vh;
}

.ge-legal-header {
  text-align: center;
  margin-bottom: 30px;
}

.ge-legal-title-section {
  position: relative;
  z-index: 2;
}

.ge-legal-icon {
  font-size: 40px;
  color: #e74c3c;
  margin-bottom: 16px;
  filter: drop-shadow(0 0 10px rgba(231, 76, 60, 0.3));
}

.ge-legal-title {
  font-size: 28px;
  font-weight: 800;
  color: white;
  margin: 0 0 8px 0;
  background: linear-gradient(135deg, #ffffff, #e74c3c);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.ge-legal-subtitle {
  font-size: 16px;
  color: #94a3b8;
  margin: 0;
}

.ge-legal-intro {
  margin-bottom: 30px;
}

.ge-legal-intro-card {
  background: rgba(23, 42, 69, 0.8);
  border: 1px solid rgba(46, 204, 113, 0.3);
  border-radius: 12px;
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 16px;
}

.ge-legal-intro-icon {
  font-size: 32px;
  color: #2ecc71;
  flex-shrink: 0;
}

.ge-legal-intro-text h3 {
  color: white;
  font-size: 18px;
  font-weight: 600;
  margin: 0 0 8px 0;
}

.ge-legal-intro-text p {
  color: #94a3b8;
  margin: 0;
  line-height: 1.5;
}

.ge-documents-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
}

.ge-document-card {
  background: rgba(23, 42, 69, 0.8);
  border: 1px solid rgba(231, 76, 60, 0.2);
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s ease;
}

.ge-document-card:hover {
  transform: translateY(-4px);
  border-color: rgba(231, 76, 60, 0.4);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
}

.ge-document-image {
  position: relative;
  height: 200px;
  overflow: hidden;
}

.ge-document-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: all 0.3s ease;
}

.ge-document-card:hover .ge-document-image img {
  transform: scale(1.05);
}

.ge-document-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(231, 76, 60, 0.9);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  opacity: 0;
  transition: all 0.3s ease;
  color: white;
}

.ge-document-card:hover .ge-document-overlay {
  opacity: 1;
}

.ge-view-icon {
  font-size: 32px;
}

.ge-document-info {
  padding: 16px;
}

.ge-document-type {
  display: inline-block;
  background: rgba(231, 76, 60, 0.1);
  color: #e74c3c;
  padding: 4px 12px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 12px;
}

.ge-document-title {
 color: white;
 font-size: 16px;
 font-weight: 600;
 margin: 0 0 8px 0;
}

.ge-document-description {
 color: #94a3b8;
 font-size: 14px;
 margin: 0 0 12px 0;
 line-height: 1.4;
}

.ge-document-date {
 display: flex;
 align-items: center;
 gap: 8px;
 color: #6b7280;
 font-size: 12px;
}

.ge-legal-notice {
 background: rgba(23, 42, 69, 0.8);
 border: 1px solid rgba(59, 130, 246, 0.3);
 border-radius: 12px;
 padding: 20px;
}

.ge-notice-content {
 display: flex;
 align-items: flex-start;
 gap: 16px;
}

.ge-notice-icon {
 font-size: 24px;
 color: #3b82f6;
 flex-shrink: 0;
 margin-top: 2px;
}

.ge-notice-text h4 {
 color: white;
 font-size: 16px;
 font-weight: 600;
 margin: 0 0 8px 0;
}

.ge-notice-text p {
 color: #94a3b8;
 margin: 0;
 line-height: 1.5;
 font-size: 14px;
}

.ge-document-modal {
 position: fixed;
 top: 0;
 left: 0;
 right: 0;
 bottom: 0;
 background: rgba(0, 0, 0, 0.9);
 display: flex;
 align-items: center;
 justify-content: center;
 z-index: 1000;
 padding: 20px;
}

.ge-modal-content {
 background: rgba(23, 42, 69, 0.95);
 border: 1px solid rgba(231, 76, 60, 0.3);
 border-radius: 16px;
 max-width: 90vw;
 max-height: 90vh;
 overflow: hidden;
 display: flex;
 flex-direction: column;
}

.ge-modal-header {
 display: flex;
 justify-content: space-between;
 align-items: center;
 padding: 20px;
 border-bottom: 1px solid rgba(231, 76, 60, 0.2);
}

.ge-modal-header h3 {
 color: white;
 font-size: 18px;
 font-weight: 600;
 margin: 0;
}

.ge-modal-close {
 width: 36px;
 height: 36px;
 background: rgba(231, 76, 60, 0.1);
 border: 1px solid rgba(231, 76, 60, 0.3);
 border-radius: 50%;
 display: flex;
 align-items: center;
 justify-content: center;
 color: #e74c3c;
 font-size: 16px;
 cursor: pointer;
 transition: all 0.3s ease;
}

.ge-modal-close:hover {
 background: rgba(231, 76, 60, 0.2);
 transform: rotate(90deg);
}

.ge-modal-body {
 padding: 20px;
 overflow-y: auto;
 flex: 1;
}

.ge-modal-body img {
 width: 100%;
 max-width: 600px;
 height: auto;
 border-radius: 8px;
 margin-bottom: 20px;
 box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

.ge-modal-info {
 background: rgba(16, 20, 31, 0.5);
 padding: 16px;
 border-radius: 8px;
 border: 1px solid rgba(231, 76, 60, 0.1);
}

.ge-modal-info p {
 color: #cbd5e1;
 margin: 0 0 8px 0;
 font-size: 14px;
}

.ge-modal-info p:last-child {
 margin-bottom: 0;
}

.ge-modal-info strong {
 color: white;
 font-weight: 600;
}

/* Mobile Responsiveness */
@media (max-width: 768px) {
 .ge-faqs-container,
 .ge-legal-container {
   padding: 16px;
 }
 
 .ge-faqs-title,
 .ge-legal-title {
   font-size: 24px;
 }
 
 .ge-faqs-subtitle,
 .ge-legal-subtitle {
   font-size: 14px;
 }
 
 .ge-faq-question {
   padding: 14px 16px;
 }
 
 .ge-faq-question-text {
   font-size: 15px;
 }
 
 .ge-terms-header {
   flex-direction: column;
   align-items: flex-start;
   gap: 16px;
 }
 
 .ge-terms-toggle-btn {
   align-self: flex-end;
 }
 
 .ge-documents-grid {
   grid-template-columns: 1fr;
   gap: 16px;
 }
 
 .ge-legal-intro-card {
   flex-direction: column;
   text-align: center;
   gap: 12px;
 }
 
 .ge-modal-content {
   max-width: 95vw;
   max-height: 95vh;
 }
 
 .ge-modal-header,
 .ge-modal-body {
   padding: 16px;
 }
}

@media (max-width: 480px) {
 .ge-faqs-container,
 .ge-legal-container {
   padding: 12px;
 }
 
 .ge-faq-item.expanded .ge-faq-answer {
   padding: 12px 16px;
 }
 
 .ge-terms-content,
 .ge-terms-item {
   padding: 16px;
 }
 
 .ge-document-image {
   height: 160px;
 }
 
 .ge-legal-intro-card {
   padding: 16px;
 }
 
 .ge-notice-content {
   flex-direction: column;
   gap: 12px;
 }
}

.ge-security-badge {
  width: 32px;
  height: 32px;
  background: rgba(46, 204, 113, 0.1);
  border: 1px solid rgba(46, 204, 113, 0.2);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #2ecc71;
  font-size: 14px;
}

.ge-wallet-actions {
  display: flex;
  gap: 10px;
}

.ge-action-btn {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 10px 12px;
  border-radius: 8px;
  border: none;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.ge-deposit-btn {
  background: linear-gradient(135deg, #e74c3c, #c0392b);
  color: white;
  box-shadow: 0 4px 12px rgba(231, 76, 60, 0.3);
}

.ge-deposit-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(231, 76, 60, 0.4);
}

.ge-withdraw-btn {
  background: rgba(51, 255, 0, 0.8);
  color:rgb(1, 2, 2), 2);
  border: 1px solid rgba(136, 146, 176, 0.2);
}

.ge-withdraw-btn:hover {
  background: rgba(231, 76, 60, 0.1);
  color: #e74c3c;
  border-color: rgba(231, 76, 60, 0.3);
  transform: translateY(-2px);
}

/* Mobile responsiveness */
@media (max-width: 768px) {
  .ge-wallet-card {
    margin: 10px;
  }
  
  .ge-wallet-content {
    padding: 14px;
  }
  
  .ge-amount {
    font-size: 20px;
  }
  
  .ge-currency {
    font-size: 12px;
  }
  
  .ge-security-badge {
    width: 28px;
    height: 28px;
    font-size: 12px;
  }
  
  .ge-action-btn {
    padding: 8px 10px;
    font-size: 12px;
    gap: 4px;
  }
}

@media (max-width: 480px) {
  .ge-wallet-actions {
    gap: 8px;
  }
  
  .ge-action-btn {
    padding: 7px 8px;
    font-size: 11px;
  }
  
  .ge-balance-label {
    font-size: 11px;
  }
}

/* About Us Section Styles */
.fp-about-container {
  padding: 28px;
  background-color: #0D1117;
  border-radius: 16px;
  position: relative;
  overflow: hidden;
}

.fp-about-container::before {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  width: 250px;
  height: 250px;
  background: radial-gradient(circle, rgba(249, 193, 1, 0.08) 0%, rgba(249, 193, 1, 0) 70%);
  z-index: 0;
}

.fp-about-header {
  position: relative;
  margin-bottom: 32px;
  text-align: center;
}

.fp-about-header-accent {
  width: 60px;
  height: 4px;
  background: linear-gradient(to right, #F9C101, #FF6B6B);
  margin: 0 auto 16px;
  border-radius: 2px;
}

.fp-about-title {
  font-size: 32px;
  font-weight: 800;
  color: #FFFFFF;
  margin-bottom: 8px;
  background: linear-gradient(to right, #FFFFFF, #F9C101);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  display: inline-block;
}

.fp-about-tagline {
  font-size: 18px;
  color: #A1A9B8;
  font-weight: 400;
}

.fp-about-cards-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 24px;
}

.fp-about-card {
  background: linear-gradient(140deg, rgba(35, 41, 54, 0.7), rgba(23, 27, 36, 0.7));
  border-radius: 16px;
  overflow: hidden;
  position: relative;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  border: 1px solid rgba(249, 193, 1, 0.1);
}

.fp-about-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  border-color: rgba(249, 193, 1, 0.3);
}

.fp-card-mission {
  border-top: 3px solid #F9C101;
}

.fp-card-approach {
  border-top: 3px solid #FF6B6B;
}

.fp-card-technology {
  border-top: 3px solid #4ECDC4;
}

.fp-card-security {
  border-top: 3px solid #7A5CF0;
}

.fp-card-icon-wrapper {
  position: relative;
  width: 60px;
  height: 60px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 24px 0 0 24px;
}

.fp-card-mission .fp-card-icon-wrapper {
  background-color: rgba(249, 193, 1, 0.1);
}

.fp-card-approach .fp-card-icon-wrapper {
  background-color: rgba(255, 107, 107, 0.1);
}

.fp-card-technology .fp-card-icon-wrapper {
  background-color: rgba(78, 205, 196, 0.1);
}

.fp-card-security .fp-card-icon-wrapper {
  background-color: rgba(122, 92, 240, 0.1);
}

.fp-card-icon {
  font-size: 26px;
  z-index: 2;
}

.fp-card-mission .fp-card-icon {
  color: #F9C101;
}

.fp-card-approach .fp-card-icon {
  color: #FF6B6B;
}

.fp-card-technology .fp-card-icon {
  color: #4ECDC4;
}

.fp-card-security .fp-card-icon {
  color: #7A5CF0;
}

.fp-icon-glow {
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 16px;
  filter: blur(8px);
  opacity: 0.4;
  z-index: 1;
  transition: all 0.3s ease;
}

.fp-card-mission .fp-icon-glow {
  background-color: rgba(249, 193, 1, 0.4);
}

.fp-card-approach .fp-icon-glow {
  background-color: rgba(255, 107, 107, 0.4);
}

.fp-card-technology .fp-icon-glow {
  background-color: rgba(78, 205, 196, 0.4);
}

.fp-card-security .fp-icon-glow {
  background-color: rgba(122, 92, 240, 0.4);
}

.fp-about-card:hover .fp-icon-glow {
  opacity: 0.7;
  transform: scale(1.1);
}

.fp-card-content {
  padding: 20px 24px 24px;
  position: relative;
  z-index: 2;
}

.fp-card-title {
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 12px;
}

.fp-card-mission .fp-card-title {
  color: #F9C101;
}

.fp-card-approach .fp-card-title {
  color: #FF6B6B;
}

.fp-card-technology .fp-card-title {
  color: #4ECDC4;
}

.fp-card-security .fp-card-title {
  color: #7A5CF0;
}

.fp-card-text {
  color: #D1D7E0;
  line-height: 1.7;
  font-size: 15px;
}

.fp-card-corner-accent {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 60px;
  height: 60px;
  opacity: 0.1;
  z-index: 1;
}

.fp-card-mission .fp-card-corner-accent {
  background: radial-gradient(circle at bottom right, #F9C101 0%, transparent 70%);
}

.fp-card-approach .fp-card-corner-accent {
  background: radial-gradient(circle at bottom right, #FF6B6B 0%, transparent 70%);
}

.fp-card-technology .fp-card-corner-accent {
  background: radial-gradient(circle at bottom right, #4ECDC4 0%, transparent 70%);
}

.fp-card-security .fp-card-corner-accent {
  background: radial-gradient(circle at bottom right, #7A5CF0 0%, transparent 70%);
}

/* Customer Support Section Styles */
.fp-support-container {
  padding: 28px;
  background-color: #0D1117;
  border-radius: 16px;
  position: relative;
  overflow: hidden;
}

.fp-support-container::after {
  content: '';
  position: absolute;
  bottom: -100px;
  left: -100px;
  width: 300px;
  height: 300px;
  background: radial-gradient(circle, rgba(122, 92, 240, 0.05) 0%, rgba(122, 92, 240, 0) 70%);
  z-index: 0;
}

.fp-support-header {
  text-align: center;
  margin-bottom: 32px;
  position: relative;
}

.fp-support-header-icon {
  font-size: 40px;
  color: #7A5CF0;
  margin-bottom: 16px;
  filter: drop-shadow(0 0 15px rgba(122, 92, 240, 0.5));
}

.fp-support-title {
  font-size: 28px;
  font-weight: 700;
  color: #FFFFFF;
  margin-bottom: 8px;
}

.fp-support-subtitle {
  font-size: 16px;
  color: #A1A9B8;
}

.fp-support-sections {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 24px;
}

.fp-support-section {
  background: linear-gradient(140deg, rgba(35, 41, 54, 0.8), rgba(23, 27, 36, 0.8));
  border-radius: 16px;
  overflow: hidden;
  border: 1px solid rgba(122, 92, 240, 0.1);
  transition: all 0.3s ease;
}

.fp-support-section:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15);
}

.fp-section-header {
  padding: 16px 24px;
  border-bottom: 1px solid rgba(122, 92, 240, 0.1);
  position: relative;
}

.fp-section-header::after {
  content: '';
  position: absolute;
  bottom: -1px;
  left: 0;
  width: 50px;
  height: 2px;
  background: linear-gradient(to right, #7A5CF0, transparent);
}

.fp-section-header-pill {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background-color: rgba(122, 92, 240, 0.1);
  padding: 6px 12px;
  border-radius: 20px;
  color: #FFFFFF;
  font-weight: 600;
  font-size: 14px;
}

.fp-header-pill-icon {
  color: #7A5CF0;
  font-size: 12px;
}

.fp-section-content {
  padding: 24px;
}

.fp-contact-intro {
  color: #D1D7E0;
  margin-bottom: 24px;
  line-height: 1.6;
}

.fp-contact-buttons {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 24px;
}

.fp-button {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-radius: 12px;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 600;
  font-size: 15px;
  position: relative;
  overflow: hidden;
}

.fp-whatsapp-button {
  background: linear-gradient(135deg, #25D366, #128C7E);
  color: white;
}

.fp-telegram-button {
  background: linear-gradient(135deg,rgb(41, 240, 15), #0061A7);
  color: white;
}

.fp-button::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to right, transparent, rgba(255, 255, 255, 0.1), transparent);
  transform: translateX(-100%);
  transition: transform 1s ease;
}

.fp-button:hover::before {
  transform: translateX(100%);
}

.fp-button:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 15px rgba(0, 0, 0, 0.2);
}

.fp-button-icon {
  font-size: 20px;
}

.fp-button-text {
  flex: 1;
  text-align: center;
}

.fp-button-arrow {
  font-size: 14px;
  opacity: 0.7;
}

.fp-contact-note {
  display: flex;
  gap: 12px;
  padding: 16px;
  background-color: rgba(249, 193, 1, 0.05);
  border-radius: 12px;
  border-left: 3px solid #F9C101;
}

.fp-note-icon {
  color: #F9C101;
  font-size: 20px;
  margin-top: 2px;
}

.fp-contact-note p {
  color: #D1D7E0;
  font-size: 14px;
  line-height: 1.5;
  margin: 0;
}

.fp-hours-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 24px;
}

.fp-hours-row {
  display: flex;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px dashed rgba(161, 169, 184, 0.2);
}

.fp-day {
  font-weight: 600;
  color: #A1A9B8;
  flex: 1;
}

.fp-hours-divider {
  width: 20px;
  height: 1px;
  background-color: rgba(122, 92, 240, 0.3);
  margin: 0 12px;
}

.fp-time {
  font-weight: 600;
  color: #FFFFFF;
}

.fp-closed {
  color: #FF6B6B;
}

/* Updated Legal Documents Styles for Single Image */
.ge-single-document-container {
  max-width: 800px;
  margin: 0 auto;
}

.ge-document-wrapper {
  background: rgba(23, 42, 69, 0.8);
  border: 1px solid rgba(231, 76, 60, 0.2);
  border-radius: 16px;
  overflow: hidden;
  margin-bottom: 30px;
}

.ge-document-header {
  padding: 24px;
  text-align: center;
  background: linear-gradient(135deg, rgba(231, 76, 60, 0.1), rgba(231, 76, 60, 0.05));
  border-bottom: 1px solid rgba(231, 76, 60, 0.1);
}

.ge-document-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: rgba(231, 76, 60, 0.1);
  color: #e74c3c;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 16px;
  border: 1px solid rgba(231, 76, 60, 0.2);
}

.ge-document-main-title {
  color: white;
  font-size: 24px;
  font-weight: 700;
  margin: 0 0 12px 0;
}

.ge-document-description {
  color: #94a3b8;
  font-size: 16px;
  margin: 0;
  line-height: 1.5;
}

.ge-document-image-container {
  position: relative;
  padding: 24px;
  background: rgba(16, 20, 31, 0.3);
}

.ge-document-loader {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: #94a3b8;
  gap: 16px;
}

.ge-loader-spinner {
  width: 40px;
  height: 40px;
  border: 3px solid rgba(231, 76, 60, 0.2);
  border-top: 3px solid #e74c3c;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.ge-document-image {
  width: 100%;
  height: auto;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  opacity: 0;
  transform: scale(0.95);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
  border: 2px solid rgba(231, 76, 60, 0.2);
}

.ge-document-image.loaded {
  opacity: 1;
  transform: scale(1);
}

.ge-document-image:hover {
  transform: scale(1.02);
  box-shadow: 0 12px 35px rgba(0, 0, 0, 0.3);
  border-color: rgba(231, 76, 60, 0.4);
}

.ge-document-overlay {
  position: absolute;
  top: 24px;
  left: 24px;
  right: 24px;
  bottom: 24px;
  background: rgba(231, 76, 60, 0.9);
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  opacity: 0;
  transition: all 0.3s ease;
  cursor: pointer;
  color: white;
}

.ge-document-image-container:hover .ge-document-overlay {
  opacity: 1;
}

.ge-overlay-icon {
  font-size: 48px;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));
}

.ge-overlay-text {
  font-size: 16px;
  font-weight: 600;
  text-align: center;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
}

.ge-document-details {
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.ge-detail-item {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 16px;
  background: rgba(16, 20, 31, 0.5);
  border-radius: 8px;
  border: 1px solid rgba(231, 76, 60, 0.1);
  transition: all 0.3s ease;
}

.ge-detail-item:hover {
  background: rgba(231, 76, 60, 0.05);
  border-color: rgba(231, 76, 60, 0.2);
  transform: translateX(4px);
}

.ge-detail-icon {
  font-size: 20px;
  margin-top: 2px;
  flex-shrink: 0;
}

.ge-detail-icon.success {
  color: #2ecc71;
}

.ge-detail-content h4 {
  color: white;
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 4px 0;
}

.ge-detail-content p {
  color: #94a3b8;
  font-size: 14px;
  margin: 0;
  line-height: 1.4;
}

/* Fullscreen Modal Styles */
.ge-fullscreen-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.95);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.ge-fullscreen-content {
  background: rgba(23, 42, 69, 0.95);
  border: 1px solid rgba(231, 76, 60, 0.3);
  border-radius: 16px;
  max-width: 95vw;
  max-height: 95vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  animation: slideIn 0.3s ease;
}

@keyframes slideIn {
  from { 
    opacity: 0;
    transform: scale(0.9);
  }
  to { 
    opacity: 1;
    transform: scale(1);
  }
}

.ge-fullscreen-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid rgba(231, 76, 60, 0.2);
  background: rgba(16, 20, 31, 0.5);
}

.ge-fullscreen-header h3 {
  color: white;
  font-size: 18px;
  font-weight: 600;
  margin: 0;
}

.ge-fullscreen-close {
  width: 40px;
  height: 40px;
  background: rgba(231, 76, 60, 0.1);
  border: 1px solid rgba(231, 76, 60, 0.3);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #e74c3c;
  font-size: 18px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.ge-fullscreen-close:hover {
  background: rgba(231, 76, 60, 0.2);
  transform: rotate(90deg);
}

.ge-fullscreen-body {
  padding: 20px;
  overflow-y: auto;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ge-fullscreen-image {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3);
}

/* Mobile Responsiveness */
@media (max-width: 768px) {
  .ge-document-header {
    padding: 20px 16px;
  }
  
  .ge-document-main-title {
    font-size: 20px;
  }
  
  .ge-document-description {
    font-size: 14px;
  }
  
  .ge-document-image-container {
    padding: 16px;
  }
  
  .ge-document-details {
    padding: 16px;
  }
  
  .ge-detail-item {
    padding: 12px;
  }
  
  .ge-overlay-icon {
    font-size: 36px;
  }
  
  .ge-overlay-text {
    font-size: 14px;
  }
  
  .ge-fullscreen-modal {
    padding: 10px;
  }
  
  .ge-fullscreen-header {
    padding: 16px;
  }
  
  .ge-fullscreen-body {
    padding: 16px;
  }
}

@media (max-width: 480px) {
  .ge-document-header {
    padding: 16px 12px;
  }
  
  .ge-document-image-container {
    padding: 12px;
  }
  
  .ge-document-details {
    padding: 12px;
    gap: 12px;
  }
  
  .ge-detail-item {
    flex-direction: column;
    gap: 8px;
    text-align: center;
  }
  
  .ge-detail-icon {
    align-self: center;
  }
}

.fp-response-badge {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 12px;
  background-color: rgba(78, 205, 196, 0.05);
  border-radius: 8px;
  color: #4ECDC4;
  font-size: 14px;
  font-weight: 500;
}

.fp-badge-pulse {
  width: 8px;
  height: 8px;
  background-color: #4ECDC4;
  border-radius: 50%;
  position: relative;
}

.fp-badge-pulse::after {
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: #4ECDC4;
  border-radius: 50%;
  animation: pulse-animation 2s infinite;
}

@keyframes pulse-animation {
  0% {
    transform: scale(1);
    opacity: 0.8;
  }
  50% {
    transform: scale(2);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 0;
  }
}

@media (max-width: 768px) {
  .fp-about-cards-container,
  .fp-support-sections {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  
  .fp-card-icon-wrapper {
    margin: 20px 0 0 20px;
  }
  
  .fp-support-title {
    font-size: 24px;
  }
  
  .fp-about-title {
    font-size: 28px;
  }
  
  .fp-about-container,
  .fp-support-container {
    padding: 24px;
  }
}

/* Features grid styles */
.forex-pesa-home-page-main-features-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(3, 1fr);
  gap: 10px;
  padding: 0 10px;
  margin-bottom: 1px;
}

.forex-pesa-home-page-main-feature-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: rgba(10, 17, 40, 0.5);
  border: 1px solid rgba(212, 175, 55, 0.15);
  border-radius: 16px;
  padding: 18px 10px;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.forex-pesa-home-page-main-feature-item::before {
  content: '';
  position: absolute;
  width: 150px;
  height: 150px;
  background: radial-gradient(circle, rgba(212, 175, 55, 0.07), transparent 70%);
  top: -75px;
  left: -75px;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.forex-pesa-home-page-main-feature-item:hover {
  transform: translateY(-5px);
  border-color: rgba(212, 175, 55, 0.3);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15);
}

.forex-pesa-home-page-main-feature-item:hover::before {
  opacity: 1;
}

.forex-pesa-home-page-main-feature-icon-wrapper {
  width: 46px;
  height: 46px;
  background: linear-gradient(145deg, rgba(10, 17, 40, 0.7), rgba(5, 7, 15, 0.7));
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
  position: relative;
  border: 1px solid rgba(212, 175, 55, 0.1);
  transition: all 0.3s ease;
}

.forex-pesa-home-page-main-feature-item:hover .forex-pesa-home-page-main-feature-icon-wrapper {
  background: linear-gradient(145deg, rgba(212, 175, 55, 0.15), rgba(212, 175, 55, 0.05));
  border-color: rgba(212, 175, 55, 0.2);
}

.forex-pesa-home-page-main-feature-icon {
  font-size: 20px;
  color: #D4AF37;
}

.forex-pesa-home-page-main-feature-label {
  font-size: 13px;
  font-weight: 500;
  text-align: center;
  margin: 0;
  color: #E2E8F0;
}

/* Market trends styles */
.forex-pesa-home-page-main-market-card {
  margin: 0 20px 30px;
  background: rgba(10, 17, 40, 0.5);
  border-radius: 16px;
  overflow: hidden;
  border: 1px solid rgba(212, 175, 55, 0.2);
}

.forex-pesa-home-page-main-trend-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 16px;
  border-bottom: 1px solid rgba(212, 175, 55, 0.1);
  transition: all 0.2s ease;
  position: relative;
}

.forex-pesa-home-page-main-trend-item:last-child {
  border-bottom: none;
}

.forex-pesa-home-page-main-trend-item::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 3px;
  height: 100%;
  background: transparent;
  transition: all 0.2s ease;
}

.forex-pesa-home-page-main-trend-item:hover {
  background: rgba(212, 175, 55, 0.05);
}

.forex-pesa-home-page-main-trend-item:hover::before {
  background: rgba(212, 175, 55, 0.5);
}

.forex-pesa-home-page-main-trend-featured {
  background: rgba(212, 175, 55, 0.07);
}

.forex-pesa-home-page-main-trend-featured::before {
  background: #D4AF37;
}

.forex-pesa-home-page-main-trend-info {
  display: flex;
  align-items: center;
  gap: 14px;
}

.forex-pesa-home-page-main-trend-icon {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  background: rgba(5, 7, 15, 0.5);
}

.forex-pesa-home-page-main-icon-btc { color: #F7931A; }
.forex-pesa-home-page-main-icon-eth { color: #627EEA; }
.forex-pesa-home-page-main-icon-xrp { color: #0066B1; }
.forex-pesa-home-page-main-icon-ltc { color: #B5B5B5; }
.forex-pesa-home-page-main-icon-doge { color: #C3A634; }

.forex-pesa-home-page-main-trend-details {
  display: flex;
  flex-direction: column;
}

.forex-pesa-home-page-main-trend-name {
  font-size: 15px;
  font-weight: 600;
  color: #FFFFFF;
}

.forex-pesa-home-page-main-trend-symbol {
  font-size: 12px;
  color: #A0A0A0;
}

.forex-pesa-home-page-main-trend-metrics {
  text-align: right;
}

.forex-pesa-home-page-main-trend-price {
  font-size: 15px;
  font-weight: 600;
  color: #FFFFFF;
  margin-bottom: 4px;
}

.forex-pesa-home-page-main-trend-change {
  display: inline-block;
  font-size: 12px;
  font-weight: 600;
  padding: 3px 8px;
  border-radius: 6px;
}

.forex-pesa-home-page-main-trend-change.positive {
  background: rgba(76, 175, 80, 0.1);
  color: #4CAF50;
}

.forex-pesa-home-page-main-trend-change.negative {
  background: rgba(244, 67, 54, 0.1);
  color: #F44336;
}

/* Animations */
@keyframes notificationsPanelIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes buttonShine {
  0% { transform: translateX(-100%); }
  20% { transform: translateX(100%); }
  100% { transform: translateX(100%); }
}

/* Responsive styles */
@media (max-width: 768px) {
  .forex-pesa-home-page-main-features-grid {
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(3, 1fr);
    gap: 10px;
  }
  
  .forex-pesa-home-page-main-wallet-actions {
    flex-direction: column;
    gap: 10px;
    height: 100px;
  }

  .forex-pesa-home-page-main-wallet-amount {
    font-size: 32px;
  }
  
  .forex-pesa-home-page-main-crypto-badges {
    right: 15px;
  }
}

@media (max-width: 576px) {
  .forex-pesa-home-page-main-header {
    padding: 20px 16px;
  }
  
  
  .forex-pesa-home-page-main-user-avatar {
    width: 40px;
    height: 40px;
    font-size: 18px;
  }
  
  .forex-pesa-home-page-main-user-name {
    font-size: 15px;
  }
  
  .forex-pesa-home-page-main-user-mobile {
    font-size: 12px;
  }

  
  .forex-pesa-home-page-main-crypto-selector {
    gap: 10px;
    padding: 0 15px;
  }
  
  .forex-pesa-home-page-main-crypto-option {
    min-width: 100px;
    padding: 12px;
  }
  
  .forex-pesa-home-page-main-crypto-icon {
    font-size: 24px;
  }
  
  .forex-pesa-home-page-main-crypto-name {
    font-size: 14px;
  }
  
  .forex-pesa-home-page-main-features-grid {
   grid-template-columns: repeat(3, 1fr);
   grid-template-rows: repeat(3, 1fr);
  }
  
  .forex-pesa-home-page-main-section-header {
    margin: 0 15px 14px;
  }
  
  .forex-pesa-home-page-main-section-icon {
    width: 32px;
    height: 32px;
    font-size: 16px;
  }
  
  .forex-pesa-home-page-main-section-title {
    font-size: 16px;
  }
  
  .forex-pesa-home-page-main-market-card {
    margin: 0 15px 24px;
  }
  
  .forex-pesa-home-page-main-trend-icon {
    width: 36px;
    height: 36px;
    font-size: 18px;
  }
}

@media (max-width: 360px) {
  .forex-pesa-home-page-main-feature-icon-wrapper {
    width: 40px;
    height: 40px;
  }
  
  .forex-pesa-home-page-main-feature-icon {
    font-size: 18px;
  }
  
  .forex-pesa-home-page-main-feature-label {
    font-size: 11px;
  }
  
  .forex-pesa-home-page-main-crypto-option {
    min-width: 90px;
    padding: 10px;
  }
  
  .forex-pesa-home-page-main-wallet-amount {
    font-size: 28px;
  }
}

 
        /* Welcome Popup Styles */
.welcome-popup {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(26, 26, 46, 0.9);
  backdrop-filter: blur(8px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 20px;
}

.popup-container {
  background: rgba(23, 42, 69, 0.95);
  backdrop-filter: blur(15px);
  border-radius: 16px;
  width: 100%;
  max-width: 360px;
  position: relative;
  overflow: hidden;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(231, 76, 60, 0.2);
  animation: popupSlideIn 0.3s ease-out;
}

.popup-header {
  text-align: center;
  padding: 24px 20px 16px;
  background: linear-gradient(135deg, rgba(231, 76, 60, 0.1), rgba(192, 57, 43, 0.05));
}

.logo-icon {
  font-size: 32px;
  color: #e74c3c;
  margin-bottom: 12px;
}

.popup-header h2 {
  font-size: 20px;
  font-weight: 700;
  color: white;
  margin: 0 0 6px 0;
}

.popup-header h2 span {
  color: #e74c3c;
}

.popup-header p {
  font-size: 13px;
  color: #8892b0;
  margin: 0;
}

.popup-content {
  padding: 16px 20px;
}

.popup-content p {
  font-size: 14px;
  line-height: 1.5;
  color: #cbd5e1;
  margin: 0;
  text-align: center;
}

.popup-actions {
  padding: 0 20px 24px;
}

.whatsapp-button {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 16px;
  background: #25d366;
  border: none;
  border-radius: 10px;
  color: white;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(37, 211, 102, 0.3);
}

.whatsapp-button:hover {
  background: #22c55e;
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(37, 211, 102, 0.4);
}

.close-button {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 32px;
  height: 32px;
  background: rgba(23, 42, 69, 0.8);
  border: 1px solid rgba(136, 146, 176, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #8892b0;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.close-button:hover {
  background: rgba(231, 76, 60, 0.1);
  border-color: rgba(231, 76, 60, 0.3);
  color: #e74c3c;
  transform: rotate(90deg);
}

@keyframes popupSlideIn {
  from {
    opacity: 0;
    transform: translateY(20px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* Mobile responsiveness */
@media (max-width: 480px) {
  .welcome-popup {
    padding: 16px;
  }
  
  .popup-container {
    max-width: 100%;
  }
  
  .popup-header {
    padding: 20px 16px 12px;
  }
  
  .logo-icon {
    font-size: 28px;
  }
  
  .popup-header h2 {
    font-size: 18px;
  }
  
  .popup-content {
    padding: 12px 16px;
  }
  
  .popup-content p {
    font-size: 13px;
  }
  
  .popup-actions {
    padding: 0 16px 20px;
  }
  
  .whatsapp-button {
    padding: 10px 14px;
    font-size: 13px;
  }
}

@media (max-width: 360px) {
  .popup-header h2 {
    font-size: 16px;
  }
  
  .popup-content p {
    font-size: 12px;
  }
  
  .close-button {
    width: 28px;
    height: 28px;
    font-size: 12px;
  }
}


        /* Add a smaller screen breakpoint for very small devices */
        @media (max-width: 350px) {
          .fp-popup-container {
            max-height: 85vh;
            padding-bottom: 16px;
          }
          
          .fp-popup-crypto-icons {
            height: 60px;
          }
          
          .fp-icon {
            font-size: 22px;
            margin: 0 10px;
          }
          
          .fp-logo-badge {
            width: 40px;
            height: 40px;
            margin-bottom: 10px;
          }
          
          .fp-logo-text {
            font-size: 18px;
          }
          
          .fp-benefit-icon {
            width: 36px;
            height: 36px;
            font-size: 16px;
          }
          
          .fp-benefit-text {
            font-size: 11px;
          }
          
          .fp-action-button, .fp-signout-button {
            padding: 10px;
            font-size: 12px;
          }
        }

        /* Chart Container Styles */
.forex-chart-container {
  margin: 16px;
  background: linear-gradient(135deg, rgba(10, 17, 40, 0.95), rgba(5, 7, 15, 0.9));
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  border: 1px solid rgba(212, 175, 55, 0.2);
  display: flex;
  flex-direction: column;
  position: relative;
  height: 380px;
}

/* Chart Header Styles */
.forex-chart-header {
  padding: 14px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgba(212, 175, 55, 0.1);
  position: relative;
  z-index: 2;
}

.forex-coin-selector-wrapper {
  position: relative;
}

.forex-selected-coin {
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  padding: 5px;
  border-radius: 10px;
  transition: all 0.2s ease;
}

.forex-selected-coin:hover {
  background: rgba(212, 175, 55, 0.08);
}

.forex-selected-coin::after {
  content: '▼';
  color: #D4AF37;
  font-size: 10px;
  margin-left: 8px;
}

.forex-selected-coin-icon {
  width: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(5, 7, 15, 0.5);
  border-radius: 50%;
  font-size: 20px;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(212, 175, 55, 0.2);
}

.forex-selected-coin-price {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.forex-price-value {
  font-size: 18px;
  font-weight: 700;
  color: #FFFFFF;
}

.forex-price-change {
  font-size: 13px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 2px;
}

.forex-price-change.positive {
  color: #4CAF50;
}

.forex-price-change.negative {
  color: #F44336;
}

.forex-coin-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  width: 240px;
  background: rgba(5, 7, 15, 0.95);
  border-radius: 12px;
  border: 1px solid rgba(212, 175, 55, 0.2);
  padding: 8px;
  margin-top: 5px;
  max-height: 0;
  overflow: hidden;
  opacity: 0;
  transition: all 0.3s ease;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(10px);
  z-index: 10;
}

.forex-coin-selector-wrapper:hover .forex-coin-dropdown {
  max-height: 300px;
  opacity: 1;
  padding: 8px;
}

.forex-coin-option {
  display: flex;
  align-items: center;
  padding: 8px 10px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.forex-coin-option:hover {
  background: rgba(212, 175, 55, 0.1);
}

.forex-coin-option.active {
  background: rgba(212, 175, 55, 0.15);
}

.forex-option-icon {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  margin-right: 10px;
}

.forex-option-symbol {
  flex: 1;
  font-size: 14px;
  font-weight: 600;
  color: #FFFFFF;
}

.forex-option-change {
  font-size: 12px;
  font-weight: 600;
}

.forex-option-change.positive {
  color: #4CAF50;
}

.forex-option-change.negative {
  color: #F44336;
}

.forex-timeframe-selector {
  display: flex;
  gap: 2px;
  background: rgba(5, 7, 15, 0.5);
  border-radius: 8px;
  padding: 3px;
  border: 1px solid rgba(212, 175, 55, 0.15);
}

.forex-timeframe-btn {
  padding: 5px 10px;
  background: transparent;
  border: none;
  color: #A0A0A0;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.forex-timeframe-btn:hover {
  color: #FFFFFF;
}

.forex-timeframe-btn.active {
  background: linear-gradient(135deg, rgba(212, 175, 55, 0.2), rgba(212, 175, 55, 0.05));
  color: #D4AF37;
}

/* Chart Body Styles */
.forex-chart-body {
  flex: 1;
  padding: 10px 5px 0;
  position: relative;
}

/* Chart Footer Styles */
.forex-chart-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 16px;
  border-top: 1px solid rgba(212, 175, 55, 0.1);
  background: rgba(5, 7, 15, 0.4);
}

.forex-chart-stats {
  display: flex;
  gap: 16px;
}

.forex-stat {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.forex-stat-label {
  font-size: 11px;
  color: #A0A0A0;
}

.forex-stat-value {
  font-size: 13px;
  font-weight: 600;
  color: #FFFFFF;
}

.forex-last-updated {
  font-size: 11px;
  color: #94A3B8;
}

/* Responsive styles */
@media (max-width: 768px) {
  .forex-chart-container {
    margin: 12px;
    height: 360px;
  }
  
  .forex-chart-header {
    padding: 12px;
  }
  
  .forex-selected-coin-icon {
    width: 34px;
    height: 34px;
    font-size: 18px;
  }
  
  .forex-price-value {
    font-size: 16px;
  }
  
  .forex-price-change {
    font-size: 12px;
  }
  
  .forex-timeframe-btn {
    padding: 4px 8px;
    font-size: 11px;
  }
  
  .forex-chart-stats {
    gap: 12px;
  }
}

@media (max-width: 576px) {
  .forex-chart-container {
    margin: 10px;
    height: 300px;
  }
  
  .forex-chart-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
  
  .forex-coin-selector-wrapper {
    width: 100%;
  }
  
  .forex-selected-coin {
    width: 100%;
    justify-content: space-between;
  }
  
  .forex-timeframe-selector {
    width: 100%;
    justify-content: space-between;
  }
  
  .forex-timeframe-btn {
    flex: 1;
    text-align: center;
  }
  
  .forex-chart-footer {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  
  .forex-chart-stats {
    width: 100%;
    justify-content: space-between;
  }
  
  .forex-last-updated {
    align-self: flex-end;
  }
  
  .forex-coin-dropdown {
    width: 100%;
  }
}

@media (max-width: 400px) {
  .forex-chart-container {
    height: 280px;
  }
  
  .forex-stat-label {
    font-size: 10px;
  }
  
  .forex-stat-value {
    font-size: 12px;
  }
}


        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>

      < WhatsAppFloat/>

    </div>
  );
};

export default Home;
